import moment from 'moment';
export const CONSTANT_VARIABLES = {
  // --------------------------------------------- Links
  USER_DETAILS_ADMIN_PANEL_LINK: '/dashboard/adminPanel',
  USER_DETAILS_USER_PERMISSION_LINK: '/dashboard/userPermissions',
  USER_DETAILS_NOTIFICATION_SETTINGS_LINK: '/dashboard/notificationSettings',
  MAIN_DASHBOARD_LINK: '/dashboard/',
  DASHBOARD_LINK: '/dashboard',
  OEE_DASHBOARD_LINK: '/dashboard/overallEquipmentEfficiency/',
  LINE_EFFICIENCY_DASHBOARD_LINK: '/dashboard/lineEfficiency/',
  OEE_EQUIPMENT_DASHBOARD_LINK: '/dashboard/oeeEquipmentDashboard/',
  LINE_DASHBOARD_LINK: '/dashboard/line/',
  LINE_DETAILS_DASHBOARD_LINK: '/dashboard/lineDetails/',
  EQUIPMENT_TREND_LINK: 'oeeEquipmentDashboard/:equipId/trends',
  ASSEMBLY_DASHBOARD_LINK: '/dashboard/assemblyLine/',
  ASSEMBLY_EQUIPMENT_DASHBOARD_LINK: '/dashboard/assemblyLineEquipmentDashboard/',
  ASSEMBLY_EQUIPMENT_TREND_LINK: 'assemblyLineEquipmentDashboard/:equipId/trends',
  EQUIPMENT_TREND_LINK_BUTTON: 'View Equipment Trend',
  PREVIOUS_SHIFT_DATA_BUTTON: 'View Previous Shift',
  ENERGY_DASHBOARD_LINK: '/dashboard/energy/',
  VISION_EQUIPMENT_DASHBOARD_LINK: '/dashboard/visionEquipmentDashboard/',
  JOB_DASHBOARD_LINK: '/dashboard/jobs/',
  LINE_TREND_LINK: '/dashboard/lineTrend/',
  VISION_AI_PROJECT_LINK: '/dashboard/masterdata/visionProject/',
  VISION_AI_PROJECT_DETAILS_LINK: '/dashboard/masterdata/visionProjectDetails/',
  SILOS_ASSIGNMENT_DASHBOARD: '/dashboard/silosAssignmentDashboard/',
  SILOS_ASSIGNMENT_DASHBOARD_MATERIAL_CONSUMPTION: '/dashboard/silosAssignment/materialConsumption/',
  SILOS_ASSIGNMENT_DASHBOARD_MATERIAL_ALLOCATION: '/dashboard/silosAssignment/materialAllocation/',
  SILOS_EQUIPMENT_DASHBOARD_LINK: '/dashboard/silosEquipmentDashboard/',
  VIEW_MAINTENANCE_DASHBOARD_LINK: '/dashboard/maintenanceManagement/jobHistory',
  OPERATIONS_JOB_HISTORY_LINK: '/dashboard/operations/jobHistory',
  OPERATIONS_LINE_JOB_HISTORY_LINK: '/dashboard/operations/lineJobHistory',
  VIEW_OPERATORS_OPERATIONS_LINK: '/dashboard/operations/jobOperators/',
  VIEW_DOWNTIME_OPERATIONS_LINK: '/dashboard/operations/downtime',
  VIEW_PRODUCTION_OPERATIONS_LINK: '/dashboard/operations/production/',
  VIEW_REJECTION_OPERATIONS_LINK: '/dashboard/operations/rejection/',
  VIEW_TOOL_CAVITY_TABLE: '/dashboard/toolCavity',
  //VIEW_REJECTION_OPERATIONS_LINK: '/common/operations/rejection',
  OPERATIONS_TOOL_CYCLE_TIME_LINK: '/dashboard/operations/avgCycleTime',
  MAINTENANCE_MANAGEMENT_RECURRENCE_INSTANCE_LINK: '/dashboard/maintenanceManagement/recurrenceInstance/',
  DOWNTIME_ANALYSIS_LINK: '/dashboard/report/downtimeAnalysis',
  REPORT_FACTORY_LINK: '/dashboard/report/factory',
  REPORT_SHIFT_LINK: '/dashboard/report/shift',
  REPORT_JOB_EFFECIENCY_LINK: '/dashboard/report/job',
  REPORT_REJECTION_LINK: '/dashboard/report/rejection',
  REPORT_DOWNTIME_LINK: '/dashboard/report/downtime',
  REPORT_ENERGY_LINK: '/dashboard/report/energy',
  REPORT_EQUIPMENT_EFFECIENCY_LINK: '/dashboard/report/equipmentEfficiency',
  //--------------------Analysis Report----------------------------
  REPORTS: 'Reports',
  REPORT_OEE_ANALYSIS: '/dashboard/analysisReports/OeeAnalysis',
  REPORT_PERFORMANCE_ANALYSIS: '/dashboard/analysisReports/Performance',
  REPORT_DOWNTIME_ANALYSIS: '/dashboard/analysisReports/Downtime',
  REPORT_REJECTION_ANALYSIS: '/dashboard/analysisReports/Rejection',
  REPORT_CHANGEOVER_ANALYSIS: '/dashboard/analysisReports/changeOver',
  DUMMY_LINK: '#',
  POPULAR_SITE_LINK: 'popularpipe',
  SKL_SITE_LINK: 'skl',
  STL_SITE_LINK: 'stl',
  QAULITY_ASSURANCE_LINK: '/dashboard/qualityAssuranceManagement/complaint',

  // --------------------------------------------- SignalR Connection Strings
  SIGNALR_AUTHORIZATION: '&Authorization=Bearer ',
  SIGNALR_CONNECTION_CHECK: 'Connected',
  SIGNALR_CONNECTED: ' Connection Establised',
  SIGNALR_DISCONNECTED: 'Connection Disconnected',
  SIGNALR_OEE_GRID_DASHBOARD_FACTORY: 'oeegriddashboard?factoryId=',
  SIGNALR_OEE_GRID_DASHBOARD_GROUP_FACTORY: 'oeegriddashboard?groupId={replaceValue}&factoryId=',
  SIGNALR_OEE_GRID_DASHBOARD: 'oeegriddashboard',
  SIGNALR_FACTORY_EFFICIENCY_DASHBOARD_GROUP_STATE_FACTORY:
    'factoryEfficiencyDashboard?groupId={groupIds}&state={state}&factoryId=',
  SIGNALR_FACTORY_EFFICIENCY_DASHBOARD_FACTORY: 'factoryEfficiencyDashboard?state={state}&factoryId=',
  SIGNALR_FACTORY_EFFICIENCY_DASHBOARD: 'factoryEfficiencyDashboard',
  SIGNALR_OEE_EQUIPMENT_GRID_DASHBOARD_EQUIPMENT: 'oeeequipmentdashboard?eqId=',
  SIGNALR_OEE_EQUIPMENT_GRID_DASHBOARD: 'oeeequipmentdashboard',
  SIGNALR_ASSEMBLY_GRID_DASHBOARD_FACTORY: 'assemblyDashboard?factoryId=',
  SIGNALR_ASSEMBLY_GRID_DASHBOARD: 'assemblyDashboard',
  SIGNALR_ASSEMBLY_EQUIPMENT_GRID_DASHBOARD_EQUIPMENT: 'detailAssemblyDashboard?eqId=',
  SIGNALR_ASSEMBLY_EQUIPMENT_GRID_DASHBOARD: 'detailAssemblyDashboard',
  SIGNALR_LINE_EFFICIENCY_GRID_DASHBOARD_FACTORY: 'lineEfficiencyDashboard?factoryId=',
  SIGNALR_LINE_EFFICIENCY_GRID_DASHBOARD: 'lineEfficiencyDashboard',
  SIGNALR_LINE_DETAILS_GRID_DASHBOARD_LINE: 'lineDetailsOeeDashboard?lineId={replaceValue}&factoryId=',
  SIGNALR_LINE_DETAILS_GRID_DASHBOARD: 'lineDetailsOeeDashboard',
  SIGNALR_ENERGY_DASHBOARD_FACTORY: 'energydashboard?state={state}&factoryId=',
  SIGNALR_ENERGY_DASHBOARD_GROUP_STATE_FACTORY: 'energydashboard?groupId={groupId}&state={state}&factoryId=',
  SIGNALR_ENERGY_DASHBOARD: 'energydashboard',
  SGINALR_SILOS_DASHBOARD_FACTORY: 'silosdashboard?factoryId=',
  SGINALR_SILOS_DASHBOARD: 'silosdashboard',
  SGINALR_SILOS_EQUIPMENT_DASHBOARD_EQUIPMENT: 'silosequipmentdashboard?eqId=',
  SGINALR_SILOS_EQUIPMENT_DASHBOARD: 'silosequipmentdashboard',
  SIGNALR_NOTIFICATIONS: 'activenotification',
  SIGNALR_CAMERA_HEALTH_FACTORY: 'camerahealth?factoryId=',
  SIGNALR_CAMERA_HEALTH: 'cameraHealthUpdate',

  // --------------------------------------------- Map Box Access Token
  MAPBOX_ACCESS_TOKEN: 'pk.eyJ1IjoidGhpbmd0cmF4IiwiYSI6ImNrank3MHp2bDBvbjIydm53MXR2c281aG0ifQ.P5AA5bt9PCBcJ4Os0dHGnw',

  // --------------------------------------------- User Permission Variables
  UP_GLOBAL_DASHBOARD: 'GlobalDashboard',
  UP_QualityAssurance: 'QualityAssurance',
  UP_FACTORY: 'Factory',
  UP_FACTORY_AREA: 'FactoryArea',
  UP_JOB: 'Job',
  UP_ASSIGNMENT: 'Assignment',
  UP_GROUP: 'Group',
  UP_DEPARTMENT: 'Department',
  UP_SHIFT: 'Shift',
  UP_EQUIPMENT: 'Equipment',
  UP_AUDIT_LOGS: 'AuditLogs',
  UP_LINE: 'Line',
  UP_POSITION: 'Position',
  UP_TOOL: 'Tool',
  UP_PRODUCT: 'Product',
  UP_LABOUR: 'Labour',
  UP_PRODUCTION: 'Production',
  UP_JOB_TYPE: 'JobType',
  UP_DOWNTIME: 'Downtime',
  UP_DOWNTIME_REASON: 'DownTimeReason',
  UP_REJECTION: 'Rejection',
  UP_REJECTION_REASON: 'RejectionReason',
  UP_ROI: 'RegionOfInterest',
  UP_RAW_MATERIAL: 'RawMaterial',
  UP_UNIDENTIFIED_OPERATOR: 'UnidentifiedOperator',
  UP_MAINTENANCE: 'Maintenance',
  UP_JOB_TITLES: 'JobTitles',
  UP_ERP_MAPPING: 'ERPEquipmentMapping',
  UP_VISION_PROJECT: 'VisionProject',
  // UP_VISION: 'Vision', // DEPRECATED - Removed from system, use UP_VISION_PROJECT instead

  // --------------------------------------------- Option checks
  OPTIONS_DASHBOARD: 'dashboard',
  OPTIONS_DASHBOARD_LIVE_FACTORY: 'dashboard.liveFactory',
  OPTIONS_DASHBOARD_OEE: 'dashboard.oee',
  OPTIONS_DASHBOARD_ASSEMBLY: 'dashboard.assembly',
  OPTIONS_DASHBOARD_SILOS: 'dashboard.silos',
  OPTIONS_DASHBOARD_VISION: 'dashboard.vision',
  OPTIONS_DASHBOARD_ENERGY: 'dashboard.energy',
  OPTIONS_DASHBOARD_JOBS: 'dashboard.job',
  OPTIONS_DASHBOARD_AUXILIARY: 'dashboard.auxiliary',
  OPTIONS_DASHBOARD_MAINTENANCE: 'dashboard.maintenance',
  OPTIONS_DASHBOARD_LINK_1: '/dashboard',
  OPTIONS_DASHBOARD_LINK_2: '/dashboard/',

  // --------------------------------------------- Side Bar
  SIDEBAR_GLOBAL_DASH: 'sidebar.dashboard.global.dash',
  SIDEBAR_GLOBAL_DASHBOARD: 'sidebar.dashboard.global.dashboard',
  SIDEBAR_FACTORY_DASHBOARD: 'sidebar.dashboard.factory.dashboard',
  SIDEBAR_LIVE_FACTORY: 'sidebar.dashboard.liveFactory',
  SIDEBAR_OEE: 'sidebar.dashboard.oee',
  SIDEBAR_EQUIPMENT: 'sidebar.dashboard.equipment',
  SIDEBAR_LINE_EFFICIENCY: 'sidebar.dashboard.line.efficiency',
  SIDEBAR_FACTORY_EFFICIENCY: 'sidebar.dashboard.factory.efficiency',
  SIDEBAR_OEE_EQUIPMENT: 'sidebar.dashboard.equipmentDashboard',
  SIDEBAR_OEE_EQUIPMENT_TREND: 'sidebar.dashboard.equipment.trend',
  SIDEBAR_SILOS: 'sidebar.dashboard.silos',
  SIDEBAR_SILOS_EQUIPMENT: 'sidebar.dashboard.silos.equipment',
  SIDEBAR_SILOS_ASSIGNMENT: 'sidebar.dashboard.silosAssignment',
  SIDEBAR_SILOS_ASSIGNMENT_MATERIAL_ALLOCATION: 'sidebar.dashboard.silosAssignment.materialAllocation',
  SIDEBAR_SILOS_ASSIGNMENT_MATERIAL_CONSUMPTION: 'sidebar.dashboard.silosAssignment.materialConsumption',
  SIDEBAR_VISION: 'sidebar.dashboard.vision',
  SIDEBAR_VISION_EQUIPMENT: 'sidebar.dashboard.vision.equipmentDashboard',
  SIDEBAR_AUXILIARY: 'sidebar.dashboard.auxiliary',
  SIDEBAR_WORKING_ASSEMBLY_LINE: 'sidebar.dashboard.workingAssemblyLine',
  SIDEBAR_WORKING_ASSEMBLY_LINE_TEST_FACTORY: 'sidebar.dashboard.workingAssemblyLineTestFactory',

  // --------------------------------------------- User Level Details

  // Admin Panel
  ADMIN_PANEL_TYPE: 'adminPanel',
  ADMIN_PANEL_TITLE: 'User Administration',
  ADMIN_PANEL_DESC: 'Manage user roles and permissions',

  // User Permission
  USER_PERMISSION_TITLE: 'User Permission',
  USER_PERMISSION_DESC: 'Authorization List',
  USER_PERMISSION_UPDATE_ROLE_ACTIONS: [
    { label: 'View', value: 'view', disabled: true },
    { label: 'Add', value: 'add' },
    { label: 'Edit', value: 'edit' },
    { label: 'Delete', value: 'delete' },
  ],
  USER_PERMISSION_VIEW: 'view',
  USER_PERMISSION_ADD: 'add',
  USER_PERMISSION_EDIT: 'edit',
  USER_PERMISSION_DELETE: 'delete',
  USER_PERMISSION_ADD_MODAL_ROLE_NAME_PLACEHOLDER: 'Enter Role Name',
  USER_PERMISSION_UPDATE_ROLE_ERROR: 'No Area Selected!',

  // Notification Settings
  NOTIFICATION_SETTINGS_TITLE: 'Notification Settings',
  CONTACT_DETAILS_UPDATED: 'Contact details updated successfully!.',
  ANALYSIS_REPORT_OeeAnalysis: 'Oee Analysis',
  NOTIFICATION_SETTINGS_TYPE: 'notificationSettingsType',
  NOTIFICATION_SETTINGS_UPDATE_EMAIL_PLACEHOLDER: 'Enter New Email Address',
  NOTIFICATION_SETTINGS_UPDATE_PHONE_PLACEHOLDER: 'Enter New Phone Number',

  // --------------------------------------------- Dashboards

  // Global Dashboard
  GLOBAL_DASHBOARD: 'Global',
  RESET_DB_LOADER: 'Resetting the database. Kindly refresh after 5 minutes...',
  GLOBAL_DASHBOARD_TITLE: 'Factory Dashboard',
  GLOBAL_DASHBOARD_DESCRIPTION: 'This dashboard showing current shift data',
  GLOBAL_VIEWER: 'GlobalViewer',
  GLOBAL_ADMIN: 'GlobalAdmin',
  VISION_PROJECT_VIEWER: 'VisionProjectViewer',
  VISION_PROJECT_ADMIN: 'VisionProjectAdmin',
  ROCHE_CELL_VIEWER: 'RocheCellViewer',
  MAP_VIEW: 'Map view',
  FACTORY_DASHBOARD: 'Factory Dashboard',
  FACTORY_DASHBOARD_EDIT_VIEW: 'Edit View ',
  FACTORY_DASHBOARD_VIEW: 'Factory Dashboard view',
  COMPARE_FACTORY_VIEW: 'Compare Factory view',

  CATEGROY_PERCENTAGE: '%',
  CATEGROY_FINISHED: 'finished',
  CATEGROY_MONTHS: 'months',
  CATEGROY_JOBS_OPEN: 'jobs open',
  CATEGROY_TYPE_JOB: 'jobs',
  CATEGROY_TYPE_HOURS: 'Hours',
  DB_RESET: 'Reset the portal',
  CATEGROY_TYPE_MONTHS: 'Average Machine Age',
  CATEGROY_TYPE_MAINTENANCE: 'maintenance',
  CATEGROY_TYPE_PRODUCTION: 'production',
  CATEGROY_TYPE_NO_MACHINE: 'No. Of Machines',
  CATEGROY_TYPE_TOOL_CHANGE_TIME: 'Average Tool Change Time',

  COMP_NAME_MACHINE_AGE: 'machineAge',
  DISP_NAME_MACHINE_AGE: 'Average Machine Age',
  COMP_NAME_OEE: 'totalOEE',
  DISP_NAME_OEE: 'Overall Equipment Effeciency',
  COMP_NAME_NO_MACHINE: 'totalMachine',
  DISP_NAME_NO_MACHINE: 'No. Of Machines',
  COMP_NAME_TOOL_CHANGE_TIME: 'toolChangesDownTime',
  DISP_NAME_TOOL_CHANGE_TIME: 'Average Tool Change Time',

  // OEE Dashboard
  GRID_LAYOUT: 'grid',
  CHART_LAYOUT: 'chart',
  OEE_GRID_LAYOUT_TITLE: 'OEE Grid View',
  OEE_LIST_LAYOUT_TITLE: 'OEE List View',
  OEE_SPEED_AVAILABILITY_LAYOUT_TITLE: 'Speed & Availability View',
  DASHBOARD_LAYOUT: 'dashboard',
  CIRCLE_LAYOUT: 'circle',
  DETAILED_LAYOUT: 'detailed',
  LIST_LAYOUT: 'list',
  SPEED_AVAILABILITY_LAYOUT: 'Speed & Availability',
  OEE_DASHBOARD: 'oee',
  AUXILIARY_DASHBOARD: 'auxiliary',
  ASSEMBLY_DASHBOARD: 'assembly',
  OVERALLOEE_DASHBOARD: 'overallEquipmentEfficiency',
  TILE_NO_OPERATOR: 'NO',
  TILE_MAINTENANCE: 'EM',
  TILE_NO_PLAN: 'PNR',
  TILE_TOOL_CHANGE: 'TC',
  TILE_POWER_OFF: 'DNC',
  TILE_EMPTY: '',

  // Oee Equipment Dashboard
  EQUIPMENT_DASHBOARD: 'equipmentDashboard',
  CYCLE_TIME_UNIT: 'sec',
  CYCLE_TIME: 'cycletime',
  LAST_CYCLE_TIME: 'lastCycleTime',
  ACTUAL_AVERAGE_CYCLE_TIME: 'actualAveragCycleTime',
  COSTED_CYCLE_TIME: 'costedCycleTime',

  EQUIPMENT_ENERGY_CONSUMED: 'energyConsumed',
  PLANNED_CYCLE_TIME: 'plannedCycleTime',
  PERCENTAGE_COMPLETE: 'percentageComplete',
  ESTIMATED_COMPLETION: 'estimatedCompletion',
  EQUIPMENT_TOOL_CAVITY: 'toolCavity',
  COSTED_CYCLETIME: 'costedCycleTime',
  EQUIPMENT_ACTUAL_CAVITY: 'actualCavity',
  DASHBOARD_EQUIPMENT: 'equipment',
  DASHBOARD_ASSEMBLYLINE_EQUIPMENT_KEY: 'assemblyEquipment',
  NO_CURRENT_SHIFT: 'No current shift available',
  LINE_NOT_READY: 'Line Not Ready',
  NO_JOB: 'No Job',

  // Silos Dashboard
  SILOS_DASHBOARD: 'silos',
  ALL_TILES: 'all',
  TILE_RED: 'red',
  TILE_ORANGE: 'orange',
  TILE_GREEN: 'green',
  NO_ASSIGNMENT: 'No Assignment',

  // SiloCard Constants
  CURRENT_RATE: 'Current Rate',
  WEEKLY_AVERAGE: 'Weekly Average',
  TONNES: 'Tonnes',
  NO_JOBS: 'No Jobs Available',
  UPDATED: 'Updated',
  UPDATED_LATEST: 'Latest',

  ESTIMATED_DAYS: 'Days',
  ESTIMATED_HOURS: 'Hours',
  ESTIMATED_MINUTES: 'Minutes',
  ESTIMATED_SECONDS: 'Seconds',

  // Assignment Dashboard
  RAW_MATERIAL: 'Select Raw Material',
  BATCH_NO: 'Batch No',
  PLANNED_CAPACITY: 'Planned Capacity',
  FLOW_RATE: 'Flow Rate',
  PLANNED_START: 'Planned Start',
  PLANNED_COMPLETION: 'Planned Completion',
  ASSIGNED_QUANTITY: 'Assigned Quantity',
  NOTES: 'Enter Notes',
  SILO_ASSIGNMENT_DASHBOARD: 'silosAssignmentDashboard',
  EMPTY_DASHES: '--',
  SILOS_EQUIPMENT_EMPTY_DATE: '-- -- --',
  MEASUREMENT_UNIT: {
    0: 'parts',
    1: 'kg',
    2: 'meter',
    3: 'volume',
  },
  MEASUREMENT_UNIT_ID: {
    parts: 0,
    kg: 1,
    meter: 2,
    volume: 3,
  },
  SKILL_LEVEL: {
    1: 'ThingtraxApproved',
    2: 'Approved',
    3: 'Disapproved',
  },
  SKILL_LEVEL_LIST: [
    { name: 'Thingtrax Approved', value: 1 },
    { name: 'Approved', value: 2 },
    { name: 'Disapproved', value: 3 },
  ],
  MEASUREMENT_UNIT_LIST: [
    { name: 'kg', value: 1 },
    { name: 'parts', value: 0 },
    { name: 'meter', value: 2 },
    { name: 'volume', value: 3 },
  ],
  FACTORY_REPORT_UNITS: [
    { id: 0, name: 'parts' },
    { id: 1, name: 'kg' },
    { id: 2, name: 'meter' },
  ],
  QA_COMPLAINT_STATUS_LIST: [
    { id: 1, label: 'Open' },
    { id: 2, label: 'Close' },
    { id: 3, label: 'Pending' },
  ],
  QA_COMPLAINT_SEVERITY_LIST: [
    { id: 1, name: 'Major' },
    { id: 2, name: 'Critical' },
    { id: 3, name: 'Minor' },
  ],
  QA_EIGHT_D_PROCESS_ACTION: {
    containment: { id: 1, name: 'Containment' },
    corrective: { id: 2, name: 'Corrective' },
    correctiveEffectiveness: { id: 3, name: 'CorrectiveEffectiveness' },
    preventive: { id: 4, name: 'Preventive' },
  },

  QA_EIGHT_D_PROCESS_ACTION_SUB_TYPE: {
    correctiveNonConformance: { id: 1, name: 'CorrectiveNonConformance' },
    correctiveDetection: { id: 2, name: 'CorrectiveDetection' },
    preventiveOccur: { id: 3, name: 'PreventiveOccur' },
    preventiveProtectCustomer: { id: 4, name: 'PreventiveProtectCustomer' },
    preventiveOtherMachine: { id: 5, name: 'PreventiveOtherMachine' },
  },

  QA_EIGHT_D_PROCESS_STEPS: [
    { id: 1, name: 'stepOneData' },
    { id: 2, name: 'stepTwoData' },
    { id: 3, name: 'stepThreeData' },
    { id: 4, name: 'stepFourData' },
    { id: 5, name: 'stepFiveData' },
    { id: 6, name: 'stepSixData' },
    { id: 7, name: 'stepSevenData' },
    { id: 8, name: 'stepEightData' },
  ],

  QA_8_D_COMPLAINT_OPTION_SELECT: {
    attach8d: { id: 1, value: 'attach8d' },
    create8dProcessWithComplaint: { id: 2, name: 'create8dProcessWithComplaint' },
    create8dProcessWithoutComplaint: { id: 3, name: 'create8dProcessWithoutComplaint' },
  },

  PRODUCT_MEASUREMENT_UNIT: ['part', 'kg', 'meter'],

  //Assignment Card Menu Items Constants
  EDIT: 'Edit',
  ALLOCATE_RAW_MATERIAL: 'Allocate Raw Material',
  VIEW_COMSUMPTION: 'View Comsumption',
  VIEW_RAW_MATERIAL: 'View Raw Material',
  DELETE_ASSIGNMENT: 'DELETE',
  COMPLETE: 'Complete',
  UP: 'Up',
  DOWN: 'Down',

  // Assignment Item Constants
  JOB_RAW_MATERIAL: 'Raw Material: ',
  JOB_START: 'Start: ',
  JOB_COMPLETION: 'Completion: ',
  JOB_ASSIGNED_QUANTITY: 'Assigned Quantity: ',
  JOB_TOTAL_COMSUMPTION: 'Total Consumption: ',

  // Energy dashbaord
  ENERGY_DASHBOARD: 'energy',
  ENERGY_UNIT: 'kWh',
  KW_PER_HOUR: 'kW/h',

  // Job Dashboard

  //Job Dashboard Header Tiles
  MACHINE_WITH_MOST_JOBS: 'machineWithMostJobs',
  ALL_JOBS: 'allJobs',
  MACHINE_WITH_NO_JOBS: 'machineWithNoJobs',
  MACHINE_WITH_DELAYED_JOBS: 'machineWithDelayedJobs',
  BEHIND_SCHEDULE: 'Behind schedule',
  ON_SCHEDULE: 'On schedule',

  JOB_DASHBOARD: 'job',
  CARD_LAYOUT: 'card',
  MARK_COMPLETED: 'Completed',
  JOB_COMPLETED: 'Completed',
  MARK_COMPLETE_JOB: 'complete',
  ADD_OPERATOR: 'addOperator',
  MOVE_JOB: 'move',
  DELETE_JOB: 'delete',
  STATE_CHANGE: 'state_change',
  MOVE_JOB_FROM_UNASSIGNED_TO_LINE: 'from_unassigned_to_line',
  ERP: 'Erp File',
  IMPORT: 'Import File',
  API: 'API Jobs Import',
  LABEL_ADD: '+',
  LINE_CARD_TYPE: 'LINE',
  EQUIPMENT_CARD_TYPE: 'EQUIPMENT',
  JOB_CARD_TYPE: 'JOB',
  CAMERA_HEALTH_CARD_TYPE: 'CAMERA_HEALTH',
  HOURS: 'hours',
  SHIFT: 'Shift',
  ERPWORKORDER: 'ErpWorkOrder',
  PLANNED_CYCLE_TIME_JOB: 'Planned Cycle Time',
  INLINE_MOVE: 'inline',
  ACROSS_MOVE: 'across',
  HIGHEST_PRIORITY: 1,
  MAX_QUANTITY: 10,
  ESTIMATION_VALIDATION: 'Your estimation is going above 5 years. Kindly adjust your quantity or cycle time',
  MAX_COSTED_TIME: 3,
  MAX_SETUP_MINS: 3,
  MAX_PULSE_PER_UNIT: 2,
  DEFAULT_SETUP_HOURS: 60,
  DEFAULT_PULSE_PER_METER: 1,
  DEFAULT_CYCLE_PER_PACK: 0,
  DEFAULT_BUFFER_SIZE: 0,
  SELECT_DOWNTIME_REASON: 'Select Downtime Reason',
  SELECT_DEPARTMENT: 'Select Department',
  SELECT_OPERATOR: 'Select User',
  SELECT_JOBID: 'Select Job Id',
  SELECT_FACTORY_SHIFT: 'Select Factory Shift',
  SELECT_IMPORT_JOB_SOURCE: 'Select Source',
  ADD_DOWNTIME: 'addDowntime',
  AHEAD_SCHEDULE: 'Ahead of schedule',
  PROGRESS_BAR: 'Progress Bar',
  PLANNED_DOWNTIME: 'Planned Downtime',
  LAST_RUN_AVG: 'Last Run Average',
  COSTED: 'Costed',
  UNASSIGNED_JOB_TITLE: 'Unassigned Jobs',
  UNASSIGNED_JOB: 'unassigned job',
  UNASSIGNED_JOB_LANE: 'unassigned job',
  EQUIPMENT_JOB_LANE: 'equipment job',
  LINE_JOB_LANE: 'line job',
  ASSIGNED_JOB: 'assigned job',
  PLANNED_DATE_EMPTY_ERROR: 'Planned Date should be not Empty',
  JOB_ALREADY_UPDATED_ERROR: 'Job has already been updated. The job cannot be moved again.',
  LINE_JOB_NOT_FOUND: 'Line Job not found, it might be deleted or moved to another line.',
  PLANNED_START_ERROR: 'Planned Start date must be Less than Completion date',
  PLANNED_COMPLETION_ERROR: 'Planned Completion date must be Greater than Planned date',
  EXCEL_FILE_NAME: 'Job.csv',
  EXCEL_SAMPLE_FILE_NAME: 'Thingtrax_Job-Import_Template.csv',
  EXCEL_FILE_TYPE: 'application/json, text/plain, */*',
  CSV_FILE_TYPE: 'application/json, text/csv, */*',
  UPLOAD_FILE_TITLE: 'Upload Job File',
  JOB_EXPORT_SUCCESSFULLY: 'Job file exported successfully',
  JOB_IMPORT_SUCCESSFULLY: 'Job file imported successfully',
  JOB_IMPORT_FAILED: 'Job import failed',
  TOOL_IMPORT_FAILED: 'Tool import failed',
  TOOL_IMPORT_SUCCESSFULLY: 'Tool imported successfully',
  PRODUCT_ATTRIBUTE_IMPORT_FAILED: 'Product Attribute import failed',
  PRODUCT_ATTRIBUTE_IMPORT_SUCCESSFULLY: 'Product Attribute imported successfully',
  PRODUCT_IMPORT_FAILED: 'Product import failed',
  PRODUCT_IMPORT_SUCCESSFULLY: 'Product imported successfully',
  SAMPLE_FILE_DATA:
    'Cavity,ToolWeight,ToolNumber,Measurement Unit,CostedCycleTime,ProductCode,ProductName,NoOfOperators,ProductWeight,Description,ErpWorkOrder,Quantity,SetUpTime,FactoryName,MachineId,CostedCycleTime2,PlannedStartDate (MM/dd/yyyy HH:mm),PlannedCompletionDate (MM/dd/yyyy HH:mm),Cavity2,PulsesPerUnit,Comments,FamilyWorkOrder,Rleupp,Opupp,PackSize,CaseSize,PalletSize',
  SAMPLE_PRODUCT_FILE_DATA:
    'Product Code, Name, Tool Number, Tool Cavity, Total Weight (gm), IdealCycleTime (Sec), Measurement Unit, No of operators, Factory Name, Tool Family Mould (true/false), Total Volume (litre), Tool Customer',
  SAMPLE_CREW_ROTA_FILE_DATA: 'Year,Week, Day,Date, <First Shift Name>,<Second Shift Name>, <Third Shift Name>',
  SAMPLE_TOOL_FILE_DATA:
    'Code, Description, Cavity, Weight (Kg), Costed Cycle Time (Sec), Factory Name, Measurement Unit, Total Shots, Customer',
  SAMPLE_PRODUCT_ATTRIBUTE_VALUES_FILE_DATA: 'Product Code, Attribute Name, Value, Maximum Value, Ideal Value',
  SAMPLE_GLOBAL_ATTRIBUTE_VALUES_FILE_DATA: 'Attribute Name, Data Type, Unit of Measurement, Validation Type',

  // Maintenance Dashboard
  MAINTENANCE_DASHBOARD_DESC: 'Maintenance Details',
  MAINTENANCE_DASHBOARD_ADD_TOOLTIP: 'Add Maintenance',
  MAINTENANCE_DASHBOARD_TYPES_PALCEHOLDER: 'Select Type',
  MAINTENANCE_DASHBOARD_TITLE_PALCEHOLDER: 'Enter Title...',
  MAINTENANCE_DASHBOARD_EQUIPMENT_PALCEHOLDER: 'Select Equipment',
  MAINTENANCE_DASHBOARD_EQUIPMENT_TOOL_PALCEHOLDER: 'Select Equipment/Tool',
  MAINTENANCE_DASHBOARD_TOOL_PALCEHOLDER: 'Select Tool',
  MAINTENANCE_DASHBOARD_PRIORITY_PALCEHOLDER: 'Select Priority',
  MAINTENANCE_DASHBOARD_STATUS_PALCEHOLDER: 'Select Status',
  MAINTENANCE_DASHBOARD_REASON_PALCEHOLDER: 'Select Reason',
  MAINTENANCE_DASHBOARD_REPORTED_BY_PALCEHOLDER: 'Select Reported By',
  MAINTENANCE_DASHBOARD_ASSIGNED_TO_PALCEHOLDER: 'Select Assigned To',
  MAINTENANCE_DASHBOARD_COST_ASSIGNED_TO_PALCEHOLDER: 'Select Cost Assigned To',
  MAINTENANCE_DASHBOARD_COST_PALCEHOLDER: 'Enter Cost',
  MAINTENANCE_DASHBOARD_DEPARTMENT_PALCEHOLDER: 'Select Department',
  MAINTENANCE_DASHBOARD_PART_TYPES_PALCEHOLDER: 'Select Part Types',
  MAINTENANCE_DASHBOARD_PART_LIST_PALCEHOLDER: 'Select Part List',
  MAINTENANCE_DASHBOARD_NOTES_PLACEHOLDER: 'Write Notes...',
  MAINTENANCE_DASHBOARD_ESTIMATED_EFFORT_PALCEHOLDER: 'Enter estimated effort in hours',
  MAINTENANCE_DASHBOARD_TYPES: [
    {
      label: 'Equipment',
      value: 1,
    },
    {
      label: 'Tool',
      value: 2,
    },
    {
      label: 'General',
      value: 3,
    },
  ],
  MAINTENANCE_DASHBOARD_PRIORITIES_PALCEHOLDER: 'Select Priority',
  MAINTENANCE_DASHBOARD_LABOURS_PALCEHOLDER: 'Select Assigned To Labours ',
  MAINTENANCE_DASHBOARD_TYPE_GENERAL: 'General',
  MAINTENANCE_DASHBOARD_SAVE_IMG_REMARK_PLACEHOLDER: 'Enter Remarks...',
  MAINTENANCE_DASHBOARD_TOOLTIP_VIEW_IMAGE: 'View Image',
  MAINTENANCE_DASHBOARD_TOOLTIP_PRINT_FORM: 'Print Form',
  FACTORY_EFFICIENCY_DASHBOARD_TOOLTIP_PRINT: 'Print',

  MAINTENANCE_DASHBOARD_TOOLTIP_UPLOAD_IMAGE: 'Upload Image',

  JOB_DASHBOARD_PAGE: 'JOB DASHBOARD',
  ADD_JOB_PAGE: 'ADD JOB',
  EDIT_JOB_PAGE: 'EDIT JOB',
  ADD_UNASSIGNED_JOB_PAGE: 'ADD UNASSIGNED JOB',
  EDIT_UNASSIGNED_JOB_PAGE: 'EDIT UNASSIGNED JOB',
  VIEW_JOB_PAGE: 'VIEW JOB',

  // --------------------------------------------- Reports
  FROM_TIME: 'From Time',
  TO_TIME: 'To Time',
  FROM_DATE: 'From Date',
  TO_DATE: 'To Date',
  UNPLANNED_DOWNTIME: 'Unplanned Downtime',
  TOTAL_STOP_TIME: 'Total Time of Stop Time',
  DATE: 'Date',
  KWH: 'kWh',
  KG: 'kg',
  KWH_KG: 'kWh/kg',
  RUNTIME_KWH_KG: 'Runtime kWh/kg',
  OVERALL_KWH_KG: 'Overall kWh/kg',
  ENERGY_KG: 'Energy/kg',

  // Factory Report Pdf/csv Columns
  NAME: 'Name',
  FACTORY_REPORT_MACHINES: 'Machines',
  FACTORY_REPORT_PRODUCT_NAME: 'Product',
  FACTORY_REPORT_MACHINE_STATUS: 'Machine Status',
  FACTORY_REPORT_DOWNTIME_NAME: 'Downtime Names',
  FACTORY_REPORT_MACHINE_AVAILAILITY: 'Availability',
  FACTORY_REPORT_MACHINE_IDEAL_CYCLE_TIME: 'Ideal CT',
  FACTORY_REPORT_MACHINE_AVERAGE_CYCLE_TIME: 'AVG CT',
  FACTORY_REPORT_WEIGHT: 'Piece Weight Material',
  FACTORY_REPORT_PLANNED_PRODUCTION_PCS: 'Total Production',
  FACTORY_REPORT_PLANNED_PRODUCTION_KGS: 'Target Production(Kgs)',
  FACTORY_REPORT_ACTUAL_PRODUCTION_PCS: 'Actual Production',
  FACTORY_REPORT_ACTUAL_ACTUAL_REJECTION: 'Total Rejection',
  FACTORY_REPORT_ACTUAL_SCRAP: 'Scrap (%)',
  FACTORY_REPORT_RUNTIME: 'Run Time/hr',
  FACTORY_REPORT_STOPTIME: 'Stop Time/hr',
  FACTORY_REPORT_OEE: 'OEE',
  FACTORY_REPORT_REMARKS: 'Remarks',
  FACTORY_REPORT_JOB: 'Job',
  FACTORY_REPORT_WASGTAGE: 'Rejection',
  PLANNED_QUANTITY: 'Planned Quantity',
  // FACTORY_REPORT_ESTIMATED_PRODUCTION_PCS: 'Estimated Production(Pcs)',

  //  Report Pdf Columns
  MACHINES: 'Machines',
  EQUIPMENT_LINE_REJECTION: 'Equipment/Line',
  EQUIPMENT_LINE_DOWNTIME: 'Equipment/Line',
  PRODUCT: 'Product Name',
  GROUP: 'Group',
  TOOL_NUMBER: 'Tool Number',
  TOOL_EQUIPMENT: 'Tool/Equipment',
  MAINTENANCE_STATUS: 'Status',
  MAINTENANCE_PRIORITY: 'Priority',
  ASSIGNED_TO: 'Assigned To',
  REPORTED_BY: 'Reported By',
  TDESCRIPTION: 'Tool Description',
  CREATED_DATE: 'Created Date',
  DUE_BY: 'Due By',
  START_DATE: 'Start Date',
  TITLE: 'Title',
  TOOL_ID: 'Tool ID',
  TOOL_Number: 'Tool Number',
  ERP_WORKORDER: 'ERP WORKORDER',
  Rejection_Code: 'Rejection Code',
  TOOL_SHOTS: 'Tool Shots',
  ESTIMATED_PRODUCTION_PCS: 'Estimated Production(Pcs)',
  PLANNED_PRODUCTION_PCS: 'Target Production(Pcs)',
  PLANNED_PRODUCTION_KGS: 'Target Production(Kgs)',
  ACTUAL_PRODUCTION_PCS: 'Actual Production(Pcs)',
  ACTUAL_PRODUCTION_KGS: 'Actual Production(Kgs)',
  PLANNED_START_DATE: 'Planned Start Date',
  PLANNED_FINISH_DATE: 'Planned Finish Date',
  ACTUAL_START_DATE: 'Actual Start Date',
  ACTUAL_FINISH_DATE: 'Actual Finish Date',
  TOTAL_REJECTION: 'Total Rejection',
  REJECTION: 'Rejection',
  REJECTION_DATE: 'Rejection Date',
  PRODUCTION: 'Production',
  PRODUCTION_UNIT_PRODUCT: 'Production Unit',
  GOOD_PARTS: 'Good Parts',
  JOB_STATE: 'Job Status',
  JOB: 'Job',
  JOB_ID: 'Job ID',
  REMARKS: 'Remarks',
  PLANNED_CAVITY: 'Planned Cavity',
  STOP_TIME: 'Stop Time',
  RUNTIME: 'Runtime',
  COSTED_UNIT_TIME_PRODUCT: 'Costed Unit Time',
  AVERAGE_UNIT_TIME: 'Average Unit Time',
  CAVITY: 'Cavity',
  QUANTITY: 'Quantity',
  SCRAP_PERCENTAGE: 'Scrap %',
  REJECTION_REASON: 'Rejection Reason',
  DOWNTIME_REASON: 'Downtime Reason',
  REMAINING_HOURS: 'Remaining Hours',
  CUSTOMER_Name: 'Customer Name',
  FACTORY_Name: 'Factory Name',
  COMMENT: 'Comment',
  OEE: 'OEE',
  JOB_QUANTITY: 'Planned Quantity',
  WASGTAGE: 'Rejection',
  ACTUAL_PRODUCT_WEIGHT: 'Actual Product Weight',
  ACTUAL_CYCLE_TIME: 'Actual Cycle Time',
  ST_PRODUCT_WEIGHT: 'Standard Product Weight',
  ST_CYCLE_TIME: 'Standard Cycle Time',
  CAVITY_UTILIZATION: 'Utilization',
  ACTUAL_CAVITY: 'Actual Cavity',
  DISABLED_CAVITY: 'Disabled Cavity',
  SCRAPPED_CAVITY: 'Scrapped Cavity',
  ST_CAVITY: 'St Cavity',
  TOTAL_OEE: 'Total OEE',
  TOTAL_TIME: 'Total Time',
  PERCENT: '%',
  ACTUAL_GOODS_TOTAL_KGS: 'Actual Production Kgs - Total Kgs ',
  ACTUAL_GOODS_TOTAL_PERCENT: 'Actual Production Kgs - Total %',
  ACTUAL_GOODS_REJ_PERCENT: 'Actual Production Kgs - Rejection %',
  ACTUAL_GOODS_PERCENT: 'Actual Production Kgs - Good %',
  ACTUAL_PROD_PERCENT: 'Actual Production %',
  ACTUAL_PROD_PCS: 'Actual Production Pcs',
  ACTUAL_GOODS_REJECTION_KGS: 'Actual Production Kgs - Rejection Kgs',
  GOOD_PROD_REJ_PERCENT: 'Rejection %',
  GOOD_PROD_REJ_PCS: 'Rejection Pcs',
  GOOD_PROD_PERCENT: 'Good Production %',
  GOOD_PROD_PCS: 'Good Production Pcs',
  ACTUAL_GOODS_KGS: 'Actual Production Kgs - Good Kgs',
  PLANNED_PROD_KGS: 'Planned Production Kgs',
  PLANNED_PROD_PCS: 'Planned Production Pcs',
  ACTUAL_PRODUCTION: 'Actual Production',
  PCS: 'Pcs',
  KGS: 'Kgs',

  JOB_OEE: 'OEE',
  JOB_BALANCE: 'Balance',
  JOB_ESTIMATED_COMPLETION: 'Estimated Completion Time',
  JOB_PERCENTAGE_COMPLETE: 'Progress',
  JOB_TOTAL_PRODUCTION: 'Total Production',
  JOB_TOTAL_REJECTION: 'Total Rejection',
  JOB_CYCLE_TIME: 'Cycle Time',
  JOB_COSTED_TIME: 'Costed Time',
  // Energy Report Pdf Columns
  Equipment_ID: 'Equipment ID',
  COST: 'Cost',
  KWH_CONSUMED: 'kWh_Consumed',
  DOWNTIME_KWH: 'Downtime_kWh',
  MATERIAL_CONSUMED: 'Material Consumed (kg)',
  PRODUCT_NUMBER: 'Product Number',
  UPC_NUMBER: 'Unit Per Cycle Number',
  ENERGY_CONSUMED: 'Energy Consumed',

  // Report Downtime Analysis
  DOWNTIME_ANALYSIS: 'Downtime Analysis',

  // -------------------------------------------- Operations
  // Downtime
  OPERATIONS_DOWNTIME_TITLE: 'Downtime',
  OPERATIONS_DOWNTIME_DESC: 'All Downtime Details',
  OPERATIONS_DOWNTIME_ADD_TOOLTIP: 'Add Downtime',
  OPERATIONS_DOWNTIME_MODAL_EQUIPMENT_PLACEHOLDER: 'Select Equipment',
  OPERATIONS_DOWNTIME_MODAL_REASON_PLACEHOLDER: 'Select Downtime Reason',
  OPERATIONS_DOWNTIME_MODAL_CATEGORY_PLACEHOLDER: 'Select Downtime Category',
  OPERATIONS_DOWNTIME_MODAL_FROM_TIME_VALIDATION: 'From time should be less than To time!',
  OPERATIONS_DOWNTIME_MODAL_FROM_TIME_CURRENT_TIME_VALIDATION:
    'From time should be greater than or equal to Current time!',
  OPERATIONS_DOWNTIME_MODAL_TO_TIME_REQUIRED: 'To time required!',
  OPERATIONS_DOWNTIME_MODAL_TO_TIME_VALIDATION: 'To time should be greater than From time!',
  OPERATIONS_DOWNTIME_ADD_DOWNTIME_NAME: 'Downtime object',
  OPERATIONS_DOWNTIME_ADD_BULK: 'Add Bulk Downtime',
  OPERATIONS_DOWNTIME_CLEAR_BULK: 'Clear',

  // Production
  OPERATIONS_PRODUCTION_TITLE: 'Production',
  OPERATIONS_PRODUCTION_DESC: 'All Production Details',
  OPERATIONS_PRODUCTION_ADD_TOOLTIP: 'Add Production',
  OPERATIONS_PRODUCTION_MODAL_EQUIPMENT_PLACEHOLDER: 'Select Equipment',
  OPERATIONS_PRODUCTION_MODAL_FROM_TIME_VALIDATION: 'From time should be less than To time!',
  OPERATIONS_PRODUCTION_MODAL_TO_TIME_REQUIRED: 'To time required!',
  OPERATIONS_PRODUCTION_MODAL_TO_TIME_VALIDATION: 'To time should be greater than From time!',
  OPERATIONS_PRODUCTION_MODAL_COMMENT_JOB_PLACEHOLDER: 'Enter Comments on Job production',

  // Rejection
  OPERATIONS_REJECTION_TITLE: 'Rejection',
  OPERATIONS_REJECTION_DESC: 'All Rejection Details',
  OPERATIONS_REJECTION_ADD_TOOLTIP: 'Add Rejection',
  OPERATIONS_REJECTION_MODAL_REASON_FOR_MANUAL_PRODUCTION: 'Enter reason for manual Rejection',

  // Job Operators
  OPERATIONS_JOB_OPERATOR_TITLE: 'Job Users',
  OPERATIONS_JOB_OPERATOR_DESC: 'List of Job Related Users',
  OPERATIONS_JOB_OPERATOR_ADD_TOOLTIP: 'Add Job User',

  // Job History
  OPERATIONS_JOB_HISTORY_TITLE: 'Job History',
  OPERATIONS_LINE_JOB_HISTORY_TITLE: 'Line Job History',
  OPERATIONS_JOB_HISTORY_DESC: 'Job History - Completed Jobs',
  OPERATIONS_LINE_JOB_HISTORY_DESC: 'Line Job History - Completed Jobs',
  OPERATIONS_JOB_HISTORY_SEARCH: 'Search by Job Id/Work Order/Tool No.',
  OPERATIONS_LINE_JOB_HISTORY_SEARCH: 'Search by Line Job Id/Tool No./Erp Work Order',

  // Job Import History
  OPERATIONS_JOB_IMPORT_HISTORY_TITLE: 'Job Import History',
  OPERATIONS_JOB_IMPORT_HISTORY_DESC: 'Job Import History - Import Jobs Results',
  OPERATIONS_JOB_IMPORT_HISTORY_SEARCH: 'Search by File Name',

  // Unidentified Operator
  OPERATIONS_UNIDENTIFIED_OPERATORS_TITLE: 'Unidentified Users',
  OPERATIONS_UNIDENTIFIED_OPERATORS_DESC: 'All Unidentified Users Details',

  // Unassigned Job
  OPERATIONS_UNASSIGNED_JOB_TITLE: 'Unassigned Job',
  OPERATIONS_UNASSIGNED_JOB_DESC: 'All Unassigned Jobs Details',
  OPERATIONS_UNASSIGNED_JOB_ADD_TOOLTIP: 'Add Unassigned Job',
  OPERATIONS_UNASSIGNED_JOB_ON_SCHEDULE: 'OnSchedule',

  // ERP Equipment Mapping Data
  OPERATIONS_ERP_EQUIPMENT_MAPPING_TITLE: 'ERP EQUIPMENT MAPPING',
  OPERATIONS_ERP_EQUIPMENT_MAPPING_DESC: 'All ERP Equipment Mappings',
  OPERATIONS_ERP_EQUIPMENT_MAPPING_ADD_TOOLTIP: 'Add ERP Equipment Mapping',

  // ERP Job Import Logs Data
  OPERATIONS_ERP_JOB_IMPORT_LOGS_TITLE: 'ERP Job Import Logs',
  OPERATIONS_ERP_JOB_IMPORT_LOGS_DESC: 'All ERP Job Import Logs',
  OPERATIONS_ERP_JOB_IMPORT_LOGS_SEARCH: 'Search by ERP WorkOrder',

  // User Skill
  OPERATIONS_OPERATOR_SKILL_TITLE: 'User Skill',
  OPERATIONS_OPERATOR_SKILL_DESC: 'All User Skill Details',
  OPERATIONS_OPERATOR_SKILL_ADD_TOOLTIP: 'Add User Skill',
  OPERATIONS_OPERATOR_SKILL_LEVEL_APPROVED: 'Approved',
  OPERATIONS_OPERATOR_SKILL_LEVEL_DISAPPROVED: 'Disapproved',
  OPERATIONS_OPERATOR_SKILL_LEVEL_OPTIONS: [
    { id: 1, name: 'Thingtrax Approved' },
    { id: 2, name: window.location.host.split('.')[0].toUpperCase() + ' Approved' },
    { id: 3, name: window.location.host.split('.')[0].toUpperCase() + ' Disapproved' },
  ],
  OPERATIONS_OPERATOR_SKILL_LEVEL: [
    '',
    'Thingtrax Approved',
    window.location.host.split('.')[0].toUpperCase() + ' Approved',
    window.location.host.split('.')[0].toUpperCase() + ' Disapproved',
  ],

  // Tool Cycle Time
  OPERATIONS_TOOL_CYCLE_TIME_TITLE: 'Tool Cycle Time',
  OPERATIONS_TOOL_CYCLE_TIME_TOOL_NUMBER: 'Tool Number',
  OPERATIONS_TOOL_CYCLE_TIME_DESCRIPTION: 'Description',
  OPERATIONS_TOOL_CYCLE_TIME_CAVITY: 'Cavity',
  OPERATIONS_TOOL_CYCLE_TIME_PLANNED: 'Planned Cycle Time',
  OPERATIONS_TOOL_CYCLE_TIME_ACTUAL: 'Actual Cycle Time',
  OPERATIONS_TOOL_CYCLE_TIME_DIFF: 'Diff Cycle Time',

  // --------------------------------------------- Management Maintenance Data
  // Parts
  MAINTENANCE_MANAGEMENT_PART_TITLE: 'Maintenance Parts',
  MAINTENANCE_MANAGEMENT_PART_DESC: 'Maintenance Parts Details',
  MAINTENANCE_MANAGEMENT_PART_INPUT_NAME_PLACEHOLDER: 'Enter Part Name',
  MAINTENANCE_MANAGEMENT_PART_TYPE_PLACEHOLDER: 'Select Part Type',
  MAINTENANCE_MANAGEMENT_PART_TYPE_ADD_TOOLTIP: 'Add Maintenance Part',
  MAINTENANCE_MANAGEMENT_PART_SUCCESS_ADD: 'Maintenance part added successfully!',
  MAINTENANCE_MANAGEMENT_PART_SUCCESS_UPDATE: 'Maintenance part updated successfully!',
  MAINTENANCE_MANAGEMENT_PART_SUCCESS_DELETE: 'Maintenance part deleted successfully!',
  // Part Types
  MAINTENANCE_MANAGEMENT_PART_TYPES_TITLE: 'Maintenance Part Types',
  MAINTENANCE_MANAGEMENT_PART_TYPES_DESC: 'Maintenance Part Types Details',
  MAINTENANCE_MANAGEMENT_PART_TYPES_INPUT_NAME_PLACEHOLDER: 'Enter Part Type Name',
  MAINTENANCE_MANAGEMENT_PART_TYPES_ADD_TOOLTIP: 'Add Maintenance Part Type',
  MAINTENANCE_MANAGEMENT_PART_TYPES_SUCCESS_ADD: 'Maintenance part type added successfully!',
  MAINTENANCE_MANAGEMENT_PART_TYPES_SUCCESS_UPDATE: 'Maintenance part type updated successfully!',
  MAINTENANCE_MANAGEMENT_PART_TYPES_SUCCESS_DELETE: 'Maintenance part type deleted successfully!',
  // Maintenance Types
  MAINTENANCE_MANAGEMENT_TYPES_TITLE: 'Maintenance Types',
  MAINTENANCE_MANAGEMENT_TYPES_DESC: 'Maintenance Types Details',
  MAINTENANCE_MANAGEMENT_TYPES_INPUT_NAME_PLACEHOLDER: 'Enter Type Name',
  MAINTENANCE_MANAGEMENT_TYPES_ADD_TOOLTIP: 'Add Maintenance Type',
  MAINTENANCE_MANAGEMENT_TYPES_SUCCESS_ADD: 'Maintenance type added successfully!',
  MAINTENANCE_MANAGEMENT_TYPES_SUCCESS_UPDATE: 'Maintenance type updated successfully!',
  MAINTENANCE_MANAGEMENT_TYPES_SUCCESS_DELETE: 'Maintenance type deleted successfully!',

  //Job Titles

  MASTER_JOB_TITLES_TITLE: 'Job Titles',
  MASTER_JOB_TITLES_DESC: 'Job Titles Details',
  MASTER_JOB_TITLES_INPUT_NAME_PLACEHOLDER: 'Enter Job titles Name',
  MASTER_JOB_TITLES_ADD_TOOLTIP: 'Add Job titles',
  MASTER_JOB_TITLES_SUCCESS_ADD: 'Job titles added successfully!',
  MASTER_JOB_TITLES_SUCCESS_UPDATE: 'Job titles updated successfully!',
  MASTER_JOB_TITLES_SUCCESS_DELETE: 'Job titles deleted successfully!',

  // Reason
  MAINTENANCE_MANAGEMENT_REASON_TITLE: 'Maintenance Reason',
  MAINTENANCE_MANAGEMENT_REASON_DESC: 'Maintenance Reason Details',
  MAINTENANCE_MANAGEMENT_REASON_INPUT_NAME_PLACEHOLDER: 'Enter Reason Name',
  MAINTENANCE_MANAGEMENT_REASON_ADD_TOOLTIP: 'Add Maintenance Reason',
  MAINTENANCE_MANAGEMENT_REASON_SUCCESS_ADD: 'Maintenance reason added successfully!',
  MAINTENANCE_MANAGEMENT_REASON_SUCCESS_UPDATE: 'Maintenance reason updated successfully!',
  MAINTENANCE_MANAGEMENT_REASON_SUCCESS_DELETE: 'Maintenance reason deleted successfully!',
  // Status
  MAINTENANCE_MANAGEMENT_STATUS_TITLE: 'Maintenance Status',
  MAINTENANCE_MANAGEMENT_STATUS_DESC: 'Maintenance Status Details',
  MAINTENANCE_MANAGEMENT_STATUS_INPUT_NAME_PLACEHOLDER: 'Enter Status Name',
  MAINTENANCE_MANAGEMENT_STATUS_ADD_TOOLTIP: 'Add Maintenance Status',
  MAINTENANCE_MANAGEMENT_STATUS_SUCCESS_ADD: 'Maintenance status added successfully!',
  MAINTENANCE_MANAGEMENT_STATUS_SUCCESS_UPDATE: 'Maintenance status updated successfully!',
  MAINTENANCE_MANAGEMENT_STATUS_SUCCESS_DELETE: 'Maintenance status deleted successfully!',

  // Job History
  MAINTENANCE_MANAGEMENT_JOB_HISTORY_TITLE: 'Maintenance Jobs History',
  MAINTENANCE_MANAGEMENT_JOB_HISTORY_DESC: 'Maintenance Jobs Details',
  MAINTENANCE_MANAGEMENT_JOB_SUCCESS_UPLOAD: 'Data uploaded successfully!',
  MAINTENANCE_MANAGEMENT_JOB_SUCCESS_ADD: 'Maintenance Job added successfully!',
  MAINTENANCE_MANAGEMENT_JOB_SUCCESS_UPDATE: 'Maintenance Job updated successfully!',
  MAINTENANCE_MANAGEMENT_JOB_SUCCESS_DELETE: 'Maintenance Job deleted successfully!',

  // Recurrence Schedule
  MAINTENANCE_MANAGEMENT_RECURRENCE_TITLE: 'Recurring Maintenance Schedule',
  MAINTENANCE_MANAGEMENT_RECURRENCE_FOR: [
    { id: 1, name: 'Equipment' },
    { id: 2, name: 'Tool' },
    { id: 3, name: 'General' },
  ],
  MAINTENANCE_MANAGEMENT_RECURRENCE_JOB_TYPE: [
    { id: 1, name: 'Days', prefix: 'value in Days' },
    { id: 2, name: 'Shots', prefix: 'value in Shots' },
    { id: 3, name: 'Runtime', prefix: 'value in Hrs' },
  ],
  MAINTENANCE_MANAGEMENT_RECURRENCE_JOB_TYPE_GENERAL: [{ id: 1, name: 'Days', prefix: 'value in Days' }],
  MAINTENANCE_MANAGEMENT_RECURRENCE_JOB_TYPE_EQUIPMENT: [
    { id: 1, name: 'Days', prefix: 'value in Days' },
    { id: 3, name: 'Runtime', prefix: 'value in Hrs' },
  ],
  MAINTENANCE_MANAGEMENT_RECURRENCE_JOB_TYPE_TOOL: [
    { id: 1, name: 'Days', prefix: 'value in Days' },
    { id: 2, name: 'Shots', prefix: 'value in Shots' },
  ],
  MAINTENANCE_MANAGEMENT_RECURRENCE_ADD_TOOLTIP: 'Add Recurring Maintenance Schedule',
  MAINTENANCE_MANAGEMENT_RECURRENCE_TITLE_PLACEHOLDER: 'Enter Title',
  MAINTENANCE_MANAGEMENT_RECURRENCE_FOR_PLACEHOLDER: 'Select Recurrence Job For',
  MAINTENANCE_MANAGEMENT_RECURRENCE_JOB_TYPE_PLACEHOLDER: 'Select Recurrence Job Type',
  MAINTENANCE_MANAGEMENT_RECURRENCE_ASSIGNED_TO_PLACEHOLDER: 'Select Assigned To',
  MAINTENANCE_MANAGEMENT_RECURRENCE_VALUE_PLACEHOLDER: 'Recurrence Value in Numbers',
  MAINTENANCE_MANAGEMENT_RECURRENCE_THRESHOLD_PLACEHOLDER: 'Enter Threshold Value in Numbers',
  MAINTENANCE_MANAGEMENT_RECURRENCE_NOTES_PLACEHOLDER: 'Write Notes...',
  MAINTENANCE_MANAGEMENT_RECURRENCE_SUCCESS_ADD: 'Recurring maintenance schedule added successfully!',
  MAINTENANCE_MANAGEMENT_RECURRENCE_SUCCESS_UPDATE: 'Recurring maintenance schedule updated successfully!',
  MAINTENANCE_MANAGEMENT_RECURRENCE_SUCCESS_DELETE: 'Recurring maintenance schedule deleted successfully!',
  DOWNTIME_REASON_HIGHLIGHTS_UPDATED: 'Downtime reason highlights updated successfully!',

  // Recurrence Instance
  MAINTENANCE_MANAGEMENT_RECURRENCE_INSTANCE_TITLE: 'Assign Maintenance Schedule',
  MAINTENANCE_MANAGEMENT_RECURRENCE_INSTANCE_EQUIPMENT_PLACEHOLDER: 'Select Equipment',
  MAINTENANCE_MANAGEMENT_RECURRENCE_INSTANCE_TOOL_PLACEHOLDER: 'Select Tool',
  MAINTENANCE_MANAGEMENT_RECURRENCE_INSTANCE_START_VALUE_PLACEHOLDER: 'Recurrence Start Value',
  MAINTENANCE_MANAGEMENT_RECURRENCE_INSTANCE_START_DATE_PLACEHOLDER: 'Recurrence Start Date',
  MAINTENANCE_MANAGEMENT_RECURRENCE_INSTANCE_SUCCESS_ADD: 'Recurring instance added successfully!',
  MAINTENANCE_MANAGEMENT_RECURRENCE_INSTANCE_SUCCESS_UPDATE: 'Recurring instance updated successfully!',
  MAINTENANCE_MANAGEMENT_RECURRENCE_INSTANCE_SUCCESS_DELETE: 'Recurring instance deleted successfully!',

  // Quality Assuarance
  Q_A_MANAGEMENT_CONTACT_SUCCESS_ADD: 'Contact added successfully!',
  Q_A_MANAGEMENT_CONTACT_SUCCESS_UPDATE: 'Contact updated successfully!',
  Q_A_MANAGEMENT_CONTACT_SUCCESS_DELETE: 'Contact deleted successfully!',

  Q_A_MANAGEMENT_C_S_SUCCESS_ADD: 'Complaint Source added successfully!',
  Q_A_MANAGEMENT_C_S_SUCCESS_UPDATE: 'Complaint Source updated successfully!',
  Q_A_MANAGEMENT_C_S_SUCCESS_DELETE: 'Complaint Source deleted successfully!',

  Q_A_MANAGEMENT_COMPLAINT_SUCCESS_ADD: 'Complaint added successfully!',
  Q_A_MANAGEMENT_COMPLAINT_SUCCESS_UPDATE: 'Complaint updated successfully!',
  Q_A_MANAGEMENT_COMPLAINT_SUCCESS_DELETE: 'Complaint deleted successfully!',

  Q_A_MANAGEMENT_EIGHT_D_PROCESS_SUCCESS_ADD: '8D process saved successfully',
  Q_A_MANAGEMENT_EIGHT_D_PROCESS_SUCCESS_UPDATE: '8D process updated successfully!',
  Q_A_MANAGEMENT_EIGHT_D_PROCESS_SUCCESS_DELETE: '8D process deleted successfully!',
  Q_A_MANAGEMENT_EIGHT_D_PROCESS_STATS: 'OverAll 8D',

  QUALITY_ASSURANCE_CONTACT_TITLE: 'CONTACTS',
  QUALITY_ASSURANCE_CONTACT_DESC: "Client's CONTACTS",
  QUALITY_ASSURANCE_CONTACT_INPUT_FIRST_NAME_PLACEHOLDER: 'First Name',
  QUALITY_ASSURANCE_CONTACT_INPUT_LAST_NAME_PLACEHOLDER: 'Last Name',
  QUALITY_ASSURANCE_CONTACT_INPUT_COMPANY_NAME_PLACEHOLDER: 'Company Name',
  QUALITY_ASSURANCE_CONTACT_PHONE_NUMBER_PLACEHOLDER: 'Phone Number',
  QUALITY_ASSURANCE_CONTACT_EMAIL_PLACEHOLDER: 'Email',
  QUALITY_ASSURANCE_CONTACT_ADD_TOOLTIP: 'Add Contact Part',
  QUALITY_ANSURANCE_MODAL_COMMENT_COMPLAINTS_PLACEHOLDER: 'Comments',

  QUALITY_ASSURANCE_CS_TITLE: 'COMPLAINT SOURCE',
  QUALITY_ASSURANCE_CS_DESC: 'Complaint Source',

  QUALITY_ASSURANCE_COMPLAINT_TITLE: 'Quality Assurance Management',
  QUALITY_ASSURANCE_COMPLAINT_DESC: 'This dashboard showing current shift data',
  QUALITY_ASSURANCE_COMPLAINT_REF_NO: 'Enter Refrence Number',
  QUALITY_ASSURANCE_EIGHTD_REF_NO: 'Enter 8D Refrence Number',

  QUALITY_ASSURANCE_TILES_TITLE: 'Complaints',
  QUALITY_ASSURANCE_TILES_TITLE_EIGHTD: 'Overall 8Ds',

  QUALITY_ASSURANCE_STEPS_EIGHTD_STATUS_WAIT: 'wait',
  QUALITY_ASSURANCE_STEPS_EIGHTD_STATUS_PROCESS: 'process',
  QUALITY_ASSURANCE_STEPS_EIGHTD_STATUS_FINISH: 'finish',
  QUALITY_ASSURANCE_CONTAINMENT_ACTIONS: 'Containment Actions',
  QUALITY_ASSURANCE_LOCATTIONS: 'Locations',
  QUALITY_ASSURANCE_Metrics: 'Metrics',

  SEARCH_COMPLAINT_SOURCE: 'Search Complaint Source',
  SEARCH_CONTACT: 'Select Customer',
  SEARCH_EMPLOYEE: 'Search Employee Name',
  SELECT_ASSIGNE_TO: 'Select Assignee',
  SELECT_CUSTOMER: 'Select Customer',
  SELECT_COMPLAINT_SOURCE: 'Select Complaint Source',
  SELECT_TEAM_MEMBER: 'Select Team Member',
  SELECT_MANAGER: 'Select Manager',
  SELECT_COMPLAINT: 'Select Complaint',
  WRITE_INITIAL_ACTION: 'Write Initial Action',
  WRITE_DETAIL: 'Write Details',
  SELECT_STATUS: 'Select Status',
  SELECT_TICKET: 'Select Ticket',
  SELECT_SEVERITY: 'Select Severity',
  SELECT_ACTION_TAKEN: 'Write Action Token',
  SELECT_ACTION_TAKEN_BY: 'Select Taken BY',
  SELECT_APPROVED_BY: 'Select Approved By',

  WHO_DID_PROBLEM_EFFECT: 'Who did the problem affect?',
  WHAT_WAS_THE_PROBLEM: 'What was the problem?',
  WHERE_DID_THE_PROBLEM_OCCUR: 'Where did the problem occur?',
  WHEN_DID_THE_PROBLEM_OCCUR: 'When did the problem occur?',
  WHY_DID_THE_PROBLEM_OCCUR: 'Why did the problem occur?',
  HOW_BIG_WAS_THE_PROBLEM: 'How big was the problem?',
  WHAT_IS_YOUR_PROBLEM_STATEMENT: 'What is your problem statement?',
  ADD_PROCESS_STEP: 'Add Process Step',

  HOW_IT_WAS_DETECTED: 'How it was detected',

  HOW_MANY_PART_DETECTED: 'No of Parts detected',
  OCCURANCE: 'How many time it occurs',

  // --------------------------------------------- MASTER DATA
  // Factory
  CURRENCY: 'Select Currency',
  TIME_ZONE: 'Select Time Zone',
  DESCRIPTION: 'Enter Description',
  FACTORY_PERFORMANCE: 'Enter performance',
  FACTORY_AVAILABILITY: 'Enter Availability',
  FACTORY_QUALITY: 'Enter Quality',
  COST_PER_KW: 'Enter Cost Per KW',
  EQUIPMENT_TYPE_ID: 'Select Factory Type',
  FACTORY_NAME: 'Enter Factory Name',

  // Group
  GROUP_NAME: 'Enter Group Name',
  GROUP_DESCRIPTION: 'Enter Description',

  // Department
  DEPARTMENT_NAME: 'Name',
  DEPARTMENT_DESCRIPTION: 'Description',

  // Shift
  SHIFT_NAME: 'Enter Shift Name',
  SHIFT_COMMENT: 'Comment',

  // Dowbtime Category
  DOWNTIME_CATEGORY_NAME: 'Enter Downtime Category Name',
  DOWNTIME_CATEGORY_DESCRIPTION: 'Enter Description',

  // Equipment
  EQUIPMENT_ID: 'Enter Equipment ID',
  EQUIPMENT_ENERGY_DEFAULT_VOLTAGE: 230,
  EQUIPMENT_ENERGY_POWER_FACTOR_SINGLE_PHASE: 1,
  EQUIPMENT_ENERGY_POWER_FACTOR_THREE_PHASE: 0.84,
  EQUIPMENT_SERIAL: 'Enter Serial Number',
  EQUIPMENT_ENTER_PLC_MAC_ADDRESS: 'Enter PLC Mac Address',
  EQUIPMENT_GROUP: 'Select Group',
  EQUIPMENT_GROUP_SHORT: 'Group',
  EQUIPMENT_LINE: 'Select Line',
  EQUIPMENT_POSIITION: 'Select Position',
  EQUIPMENT_TYPE: 'Select Equipment Type',
  SETUP_HOURS: 'In Minutes',
  SORT_ORDER: 'Sort Order',
  MAKE: 'Make',
  MODEL: 'Model',
  CYCLE_PER_PACK: 'Units per pack',
  AGE: 'Age',
  YEAR: 'Year Built',
  TONNAGE: 'Tonnage/Capacity',
  DEVICE_ID: 'Device ID',
  PACKING_DEVICE_ID: 'Packing Equipment',
  // Raw Material
  RAW_MATERIAL_NAME: 'Name',
  MATERIAL_CODE: 'Raw Material Code',
  RAW_MATERIAL_MEASUREMENT_UNIT: 'Select Measurement Unit',
  RATIO: 'Ratio',

  // Line
  LINE_ID: 'Enter Line ID',
  LINE_NAME: 'Enter Line Name',
  LINE_CREATED: 'Line created successfully',
  LINE_UPDATED: 'Line updated successfully',
  LINE_DELETED: 'Line deleted successfully',

  // Line Rejection
  LINE_REJECTION_CREATED: 'Line Rejection Created',
  AUTO_RECONCILE_SUCCESSFULLY: 'Auto Reconcile Successfully',
  LINE_REJECTION_UPDATED: 'Line Rejection Updated Successfully',
  LINE_REJECTION_DELETED: 'Line Rejection Deleted Successfully',

  // Rework
  REWORK_CREATED: 'Rework Created',
  REWORK_UPDATED: 'Rework Updated Successfully',
  REWORK_DELETED: 'Rework Deleted Successfully',
  // Good Count
  LINE_GOOD_COUNT_CREATED: 'Good Count Created',

  // Position
  ORDER_NO: 'Order No',
  POSITION_NAME: 'Enter Position Name',
  Maximum_Accumulation_Qty: 'Maximum Accumulation Qty(units)',
  POSITION_CREATED: 'Position created successfully',
  POSITION_UPDATED: 'Position updated successfully',
  POSITION_DELETED: 'Position deleted successfully',
  POSITION_ORDER_CHANGED: "Position's order changed successfully",

  // Tool
  TOOL: 'Select Tool',
  COSTED_UNIT_TIME: 'Costed Unit Time in Seconds',
  WEIGHT: 'Weight (gms)',
  VOLUME_PLACEHOLDER: 'Volume (litres)',
  LENGTH: 'Length in Meters',
  TOTAL_OPERATORS: 'No. of Users',
  TOOL_DESCRIPTION: 'Enter Text',
  TOOL_WEIGHT: 'Enter Number',
  CREDIT_AMOUNT: 'Credit Amount',
  TOOL_UNIT_PER_CYCLE: 'Unit Per Cycle',
  TOOL_MEASUREMENT_UNIT: 'Select Measurement Unit',
  TOOL_COMMENT: 'Comment',
  TOOL_CYCLE_TIME: 'Enter Number',
  TOOL_RUNNER_WEIGHT: 'Runner Weight',
  TOOL_TOTAL_SHOTS: 'Enter Number',
  TOOL_MAXIMUM_SHOTS: 'Enter Number',
  TOOL_CUSTOMER: 'Enter Text',
  TOOL_LOCATION: 'Enter Text',

  // Product
  PRODUCT_CODE: 'Product Code',
  PRODUCT_NAME: 'Name/Description',
  PRODUCTION_UNIT: 'Select Production Unit',
  PRODUCT_MASTERDATA: 'MASTERDATA',
  PRODUCT_BREADCRUMB: 'PRODUCT',
  ALL_PRODUCTS: 'ALL PRODUCTS',
  PRODUCT_ATTRIBUTE: 'ATTRIBUTE PRODUCT',
  ATTRIBUTE: 'ATTRIBUTES',
  PRODUCT_ADD_ATTRIBUTE: 'ADD ATTRIBUTE VALUE',
  ADD_PRODUCT: 'ADD PRODUCT',
  EDIT_PRODUCT: 'EDIT PRODUCT',
  SEARCH_PRODUCT_CODE: 'Search by Product Code',
  PRODUCT_ADD_ATTRIBUTE_BREADCRUMB: 'ADD ATTRIBUTE',
  PRODUCT_EDIT_ATTRIBUTE_BREADCRUMB: 'EDIT ATTRIBUTE',
  PRODUCT_SELECT_ATTRIBUTE: 'Select Attribute Name',
  PRODUCT_SELECT_DATA_TYPE: 'Select Data Type',
  PRODUCT_SELECT_DATA_TYPE_OPTION: 'Select Unit of Measurement',
  PRODUCT_ATTRIBUTE_VALUES: 'Product Attribute Values',
  PRODUCT_ATTRIBUTE_VALUES_ADD: 'Add Product Attribute',
  PRODUCT_ATTRIBUTE_VALUES_EDIT: 'Edit Product Attribute',
  PRODUCT_ATTRIBUTE_VALUES_SELECT_PRODUCT: 'Add Attribute Value: Select Product',
  PRODUCT_ATTRIBUTE_VOLUME_NOT_AVAILABLE: 'N/A',
  PRODUCT_ATTRIBUTE_IMPORT_ERROR_NOTE: 'Please download and use the provided sample file.',
  DATA_TYPE_OPTION_COUNT: 'Count',
  ALL_PRODUCTS_LIST: 'All Products',
  DATA_TYPES: {
    DECIMAL: 1,
    DATE: 2,
    ALPHANUMERIC: 3,
    BOOLEAN: 4,
    JULIAN_DATE: 5,
  },

  DATA_TYPES_CONSTANTS: {
    DECIMAL: 'Decimal',
    DATE: 'Date',
    ALPHANUMERIC: 'Alphanumeric',
    JULIAN_DATE: 'Julian Date',
  },

  // Product Attribute
  PRODUCT_ATTRIBUTE_HEADER: 'Product Attributes',
  PRODUCT_ATTRIBUTE_ADD: 'Add Product Attribute',
  PRODUCT_ATTRIBUTE_EDIT: 'Edit Product Attribute',
  PRODUCT_ATTRIBUTE_CREATED: 'Product Attribute created successfully',
  PRODUCT_ATTRIBUTE_UPDATED: 'Product Attribute updated successfully',

  ADD_JOB: 'Add Job',
  UPDATE_JOB: 'Update Job',
  ADD_UNASSIGNED_JOB: 'Add Unassigned Job',
  UPDATE_UNASSIGNED_JOB: 'Update Unassigned Job',
  VIEW_JOB: 'View Job',

  // Operator
  EMPLOYEE_NO: 'Enter Employee No.',
  FIRST_NAME: 'Enter First Name',
  LAST_NAME: 'Enter Last Name',
  JOB_TITLE: 'Select Job Title',
  LABOUR_JOB_TITLE: 'Job Title',
  DEPARTMENT: 'Select Department',
  PHONE: 'Phone',
  EMAIL: 'Email',
  TRACKER_ID: 'Tracker ID',
  Crew: 'Select Crew',
  UPLOAD: 'Upload',

  // Rejection Reason
  REJECTION_REASON_NAME: 'Name',
  REJECTION_REASON_CODE: 'Code',
  REJECTION_REASON_DESCRIPTION: 'Description',
  REJECTION_REASON_TYPE: 'Type',
  IMAGE_TYPE_REJECTED: 'Rejection',

  // Downtime Reason
  DOWNTIME_CODE: 'Enter Code',
  DOWNTIME_DESCRIPTION: 'Enter Description',
  NO_REASON_TO_SHOW: 'No reason to show',
  OPERATING_NORMALLY: 'Operating Normally',

  // Simulators
  SIMULATOR_TITLE: 'SIMULATORS',
  UNIT_PER_CYCLE: 'UPC',
  UNIT_PER_PULSE: 'UPP',

  // Factory Area
  AREA_NAME: 'Area Name',
  NETWORK_ID: 'Enter Network Id',
  FACTORY_AREA_LENGTH: 'Length in meter',
  FACTORY_AREA_WIDTH: 'Width in meter',

  //Reigon Of Interest
  INTEREST_REGION_NAME: 'Enter Region Name',
  INTEREST_REGION_FACTORY_AREA: 'Select Factory Area',
  INTEREST_REGION_LENGTH: 'Length in meter',
  INTEREST_REGION_WIDTH: 'Width in meter',
  INTEREST_REGION_X_AXIS: 'xAxis  in meter',
  INTEREST_REGION_Y_AXIS: 'yAxis  in meter',

  // --------------------------------------------- Charts Constants
  ENERGY_TREND_CHART_TITLE: 'Energy Trend for Selected Period',
  DOWNTIME_CHART_TITLE: 'Downtime',
  ENERGY_TREND_CSV_EXPORT_FILENAME: 'Energy-Trend',
  DOWNTIME_ANALYSIS_REPORT_LINE_CSV_TITLE: 'Total Downtime hours per Day',
  DOWNTIME_ANALYSIS_REPORT_BAR_CSV_TITLE: 'Total Downtime hours per Machine',
  MACHINE_BAR_CHART_CSV_EXPORT_FILENAME: 'Energy Cost By Machine',
  MACHINE_BAR_CHART_TITLE: 'Energy Cost by Machine',
  PRODUCT_BAR_CHART_CSV_EXPORT_FILENAME: 'Energy Cost By Product',
  PRODUCT_BAR_CHART_TITLE: 'Energy Cost by Product',
  DOWNTIME_BAR_CHART_CSV_EXPORT_FILENAME: 'Energy Cost By Downtime',
  DOWNTIME_BAR_CHART_TITLE: 'Energy Cost by Downtime',
  EQUIPMENT_TREND_CHART_CSV_EXPORT_FILENAME: 'Equipment Trend',
  LINE_TREND_CHART_CSV_EXPORT_FILENAME: 'Line Trend',

  // --------------------------------------------- Constant Colors
  ABNORMAL_SHOT_COLOR: '#CC0000',

  // --------------------------------------------- Rules Messages
  FACTORY_REQUIRED: 'Factory required!',
  DEPARTMENT_REQUIRED: 'Department required!',
  EQUIPMENT_REQUIRED: 'Equipment required!',
  JOB_REQUIRED: 'Job required!',
  JOB_TITLE_REQUIRED: 'Job title required!',
  TOOL_REQUIRED: 'Tool required!',
  EMPLOYEE_NO_REQUIRED: 'Employee no required!',
  FIRST_NAME_REQUIRED: 'First name required!',
  LAST_NAME_REQUIRED: 'Last name required!',
  PRODUCT_REQUIRED: 'Product required!',
  OPERATOR_REQUIRED: 'User required!',
  SKILL_LEVEL_REQUIRED: 'Skill level required!',
  REJECTION_REASON_REQUIRED: 'Rejection reason required!',
  PRODUCT_TOOL_REQUIRED: 'Product/Tool required!',
  IMAGE_TITLE_REQUIRED: 'Image title required!',

  QUANTITY_REQUIRED: 'Quantity required!',
  COSTED_UNIT_TIME_REQUIRED: 'Costed unit time required!',
  QUANTITY_GREATER_THAN_ZERO_REQUIRED: 'Quantity should be greater than 0!',
  TOOL_SHOULD_BE_FAMILY_MOLD: 'Tool should be family mold!',
  QUANTITY_SHOULD_NOT_BE_IN_DECIMAL: 'Quantity should not be in decimal!',
  QUANTITY_LESS_THAN_11_DIGITS_REQUIRED: 'Quantity should be less than 11 digits!',
  CYCLE_TIME_REQUIRED: 'Cycle time required!',
  CYCLE_TIME_GREATER_THAN_ZERO_REQUIRED: 'Cycle Time should be greater than 0!',
  CYCLE_TIME_LESS_THAN_4_DIGITS_REQUIRED: 'Cycle Time should be less than 4 digits!',
  COSTED_UNIT_TIME_REMARK_REQUIRED: 'Costed Unit Time Remark is required!',
  SETUP_MIN_REQUIRED: 'Setup Minutes required!',
  SETUP_MIN_GREATER_THAN_ZERO_REQUIRED: 'Setup Minutes should be greater than 0!',
  SORT_ORDER_ZERO_OR_GREATER_THAN_ZERO_REQUIRED: 'Sort Order should be zero or greater than zero!',
  SETUP_MIN_LESS_THAN_4_DIGITS_REQUIRED: 'Setup Minutes should be less than 4 digits!',
  JOB_CAVITY_REQUIRED: 'Job Cavity required!',
  JOB_CAVITY_GREATER_THAN_ZERO_REQUIRED: 'Job Cavity should be greater than 0 and must be an integer!',
  JOB_CAVITY_ACTUAL_CAVITY_REQUIRED: 'Job Cavity should be less than or equal to actual cavity: ',
  JOB_CAVITY_TOOL_CAVITY_ENABLED_ERROR:
    'Cavity changes must be handled through the Tool Cavity Block and Unblock section.',
  JOB_CAVITY_COLUMN: 'TOTAL CAVITIES',
  JOB_CAVITY_REMAINING: 'Total Cavities Remaining (Active Count)',
  PULSE_PER_UNIT_REQUIRED: 'Pulse Per Unit required!',
  UNITS_PER_PACK_REQUIRED: 'Units Per Pack required!',
  Maximum_Accumulation_Qty_REQUIRED: 'Maximum Accumulation Qty(units) required!',
  PULSE_PER_UNIT_GREATER_THAN_ZERO_REQUIRED: 'Pulse Per Unit should be greater than 0!',
  CYCLES_PER_PACK_GREATER_THAN_ZERO_REQUIRED: 'Units per pack should be greater than 0!',
  Maximum_Accumulation_Qty_GREATER_THAN_ZERO_REQUIRED: 'Maximum Accumulation Qty(units) should be greater than 0!',
  PULSE_PER_UNIT_LESS_THAN_3_DIGITS_REQUIRED: 'Pulse Per Unit should be less than 3 digits!',
  CYCLES_PER_PACK_LESS_THAN_3_DIGITS_REQUIRED: 'Cycle Per pack should be less than 3 digits!',
  PLANNED_START_REQUIRED: 'Planned Start Date required!',
  PLANNED_COMPLETION_REQUIRED: 'Planned Completion Date required!',
  PLANNED_QUANTITY_REQUIRED: 'Planned Quantity required!',
  PLANNED_QUANTITY_GREATER_THAN_ZERO_REQUIRED: 'Planned Quantity should be greater than 0!',
  PRODUCT_UNIT_REQUIRED: 'Product Unit required!',
  PRODUCT_WEIGHT_REQUIRED: 'Weight required!',
  PRODUCT_UNIT_GREATER_THAN_ZERO_REQUIRED: 'Product Unit should be greater than 0!',
  PRODUCT_WEIGHT_GREATER_THAN_ZERO_REQUIRED: 'Product Weight should be greater than 0!',
  DATE_REQUIRED: 'Date required!',
  FROM_TIME_REQUIRED: 'From time required!',
  SHIFT_REQUIRED: 'Shift required!',
  DURATION_REQUIRED: 'Duration Type required!',
  SELECT_HOURS_REQUIRED: 'Hours required!',
  COMMENT_REQUIRED: 'Comment Required!',
  REJECTION_REASONS_REQUIRED: 'Rejection Reason required!',
  DOWNTIME_REASON_REQUIRED: 'Downtime Reason required!',
  FROM_TIME_LESS_TO_TIME: 'From time should be less than to time!',
  FROM_TIME_GREATER_SHIFT_FROM_TIME: 'From time should be greater than shift from time!',
  TO_TIME_GREATER_FROM_TIME: 'To time should be greater than from time!',
  TO_TIME_LESS_SHIFT_TO_TIME: 'To time should be less than shift to time!',
  TO_TIME_REQUIRED: 'To time required!',

  // --------------------------------------------- placeholders for Input
  PRODUCT_NAME_PLACEHOLDER: 'Product Name',
  TOOL_LOCATION_PLACEHOLDER: 'Tool Location',
  QUANTITY_PLACEHOLDER: 'Enter Quantity in Numbers',
  OPERATORS_PLACEHOLDER: 'Enter Number of Operators',
  JOB_STATE_PLACEHOLDER: 'Job State',
  CYCLE_TIME_SECS_PLACEHOLDER: 'Cycle Time in Seconds',
  JOB_CAVITY_PLACEHOLDER: 'Enter Job Cavity',
  ERP_PLACEHOLDER: 'ERP Work Order',
  PLANNED_START_PLACEHOLDER: 'Planned Start Date',
  TARGET_DATE_PLACEHOLDER: 'Enter Target Date',
  COMPLAINT_DATE_PLACEHOLDER: 'Enter Target Date',
  PLANNED_COMPLETION_PLACEHOLDER: 'Planned Completion Date',
  ESTIMATED_COMPLETION_PLACEHOLDER: 'Estimated Completion Date',
  ESTIMATED_START_PLACEHOLDER: 'Estimated Start Date',
  DESC_PLACEHOLDER: 'Description',
  PLANNED_QUANTITY_PLACEHOLDER: 'Enter Planned Quantity in Numbers',
  COSTED_UNIT_TIME_PLACEHOLDER: 'Enter Costed Unit Time',
  ERP_CODE_PLACEHOLDER: 'Enter ERP Product Code',
  COSTED_TIME_UPDATE_PLACEHOLDER: 'Please give Remark (max 20 characters)',
  REJECTION_MODAL_PRODUCT_NAME_PLACEHOLDER: 'Select Product',
  PRODUCT_UNIT_PLACEHOLDER: 'Units in Numbers',
  REJECTION_WEIGHT_PLACEHOLDER: 'Weight in Kg',
  PRODUCT_WEIGHT_PLACEHOLDER: 'Weight (gms)',
  DATE_PLACEHOLDER: 'Enter Date',
  TIME_PLACEHOLDER: 'Enter time',
  SHIFT_PLACEHOLDER: 'Enter Shift',
  SELECT_SHIFT_PLACEHOLDER: 'Select Shift',
  SELECT_DUARTION_PLACEHOLDER: 'Select Duration Type',
  SELECT_HOURS_PLACEHOLDER: 'Select Hours From',
  REJECTION_REASON_PLACEHOLDER: 'Select Rejection Reason',
  COMMENT_JOB_REJECTION_PLACEHOLDER: 'Enter Comments on Job Rejection',
  COMMENT_JOB_PRODUCTION_PLACEHOLDER: 'Enter Comments on Job Production',
  MANUAL_PRODUCTION_REASON_PLACEHOLDER: 'Enter Reasons for Manual Production',
  JOB_TYPE_NAME_PLACEHOLDER: 'Job Type Name',
  UPDATE_DOWNTIME: 'Update Downtime',
  DOWNTIME_REASON_REMARK_REQUIRED: 'Downtime reason remark required!',
  MAX_LENGTH_DOWNTIME_REMARK: 'Max Remarks Length 50',
  DOWNTIME: 'Downtime',
  TRACKER_ID_PLACEHOLDER: 'Enter Tracker Id',
  UPDATE_KPI_MODAL_PLACEHOLDER: 'Enter Comment',

  // --------------------------------------------- Notificaiton Messages

  // Common
  SUCCESS: 'Success',
  ERROR: 'Error',
  FETCHED_SUCCESSFULLY: 'Data fetched successfully',
  UPDATED_SUCCESSFULLY: 'Data updated successfully',
  PERMISSION_PERMITTED: 'Permission denied!',
  FILE_DOWNLOADED_SUCCESSFULLY: 'File Downloaded Successfully!',
  FILE_UPLOADED_SUCCESSFULLY: 'File Uploaded Successfully!',

  // Job Dashboard
  JOB_CREATED: 'Job created successfully',
  CAVITY_UPDATED: 'Tool Cavity Updated Successfully',
  LINE_JOB_CREATED: 'Line Job created successfully',

  LINE_JOB_UPDATED: 'Line Job updated successfully',
  JOB_UPDATED: 'Job updated successfully',
  PNR_DOWNTIME_CREATED: ' Planned No run Downtime added',
  JOB_MOVED: 'Job moved successfully',
  MACHINE_STATUS_CHANGED: 'Machine status changed successfully',
  JOB_MARK_COMPLETED: 'Job mark completed successfully',
  JOB_ALREADY_COMPLETED: 'This Job is already marked as completed.',
  VISION_PROJECT_NOT_DEPLOYED: 'Vision project for this product is not yet deployed.',
  JOB_DELETED: 'Job deleted successfully',

  // Operations Data
  AVG_CYCLE_TIME_UPDATED: 'Avg Cycle Time updated successfully',

  JOB_HISTORY_UPDATED: 'Job History updated successfully',

  UNASSIGNED_JOB_CREATED: 'Unassigned Job created successfully',
  UNASSIGNED_JOB_UPDATED: 'Unassigned Job updated successfully',
  UNASSIGNED_JOB_DELETED: 'Unassigned Job deleted successfully',

  JOB_OPERATOR_CREATED: 'Job User created successfully',
  JOB_OPERATOR_UPDATED: 'Job User updated successfully',
  JOB_OPERATOR_DELETED: 'Job User deleted successfully',

  UNIDENTIFIED_OPERATOR_UPDATED: 'Unidentified User updated successfully',

  PRODUCTION_CREATED: 'Production created successfully',
  JOB_PRODUCTION_ADDED: 'Job production added successfully',
  PRODUCTION_UPDATED: 'Production updated successfully',
  PRODUCTION_DELETED: 'Production deleted successfully',

  REJECTION_CREATED: 'Rejection created successfully',
  JOB_REJECTION_ADDED: 'Job rejection added successfully',
  REJECTION_UPDATED: 'Rejection updated successfully',
  REJECTION_DELETED: 'Rejection deleted successfully',

  DOWNTIME_CREATED: 'Downtime created successfully',
  DOWNTIME_UPDATED: 'Downtime updated successfully',
  DOWNTIME_DELETED: 'Downtime deleted successfully',
  DOWNTIME_CLOSED: 'Downtime closed successfully',

  // Master Data
  FACTORY_CREATED: 'Factory created successfully',
  FACTORY_UPDATED: 'Factory updated successfully',

  GROUP_CREATED: 'Group created successfully',
  GROUP_UPDATED: 'Group updated successfully',

  SIMULATOR_UPDATED: 'Simulator updated successfully',

  DEPARTMENT_CREATED: 'Department created successfully',
  DEPARTMENT_UPDATED: 'Department updated successfully',

  SHIFT_CREATED: 'Shift created successfully',
  SHIFT_UPDATED: 'Shift updated successfully',
  SHIFT_EXISTED: 'Shift is already existed',

  EQUIPMENT_CREATED: 'Equipment created successfully',
  EQUIPMENT_UPDATED: 'Equipment updated successfully',

  RAW_MATERIAL_CREATED: 'Raw Material created successfully',
  RAW_MATERIAL_UPDATED: 'Raw Material updated successfully',
  RAW_MATERIAL_DELETED: 'Raw Material deleted successfully',

  JOB_TYPE_CREATED: 'Job Type created successfully',
  JOB_TYPE_UPDATED: 'Job Type updated successfully',
  JOB_TYPE_DELETED: 'Job Type deleted successfully',

  TOOL_CREATED: 'Tool created successfully',
  TOOL_UPDATED: 'Tool updated successfully',
  TOOL_DELETED: 'Tool deleted successfully',

  PRODUCT_CREATED: 'Product created successfully',
  PRODUCT_UPDATED: 'Product updated successfully',
  PRODUCT_DELETED: 'Product deleted successfully',

  PRODUCT_ATTRIBUTE_VALUES_CREATED: 'Product attribute value created successfully',
  PRODUCT_ATTRIBUTE_VALUES_UPDATED: 'Product attribute value updated successfully',
  PRODUCT_ATTRIBUTE_VALUES_DELETED: 'Product attribute value deleted successfully',

  OPERATORS_CREATED: 'User created successfully',
  OPERATORS_UPDATED: 'User updated successfully',
  OPERATORS_DELETED: 'User deleted successfully',

  OPERATOR_SKILL_CREATED: 'User skill created successfully',
  OPERATOR_SKILL_UPDATED: 'User skill updated successfully',
  OPERATOR_SKILL_DELETED: 'User skill deleted successfully',

  ERP_EQUIPMENT_MAPPING_CREATED: 'ERP Equipment Mapping created successfully',
  ERP_EQUIPMENT_MAPPING_UPDATED: 'ERP Equipment Mapping updated successfully',
  ERP_EQUIPMENT_MAPPING_DELETED: 'ERP Equipment Mapping deleted successfully',

  REJECTION_REASON_CREATED: 'Rejection Reason created successfully',
  REJECTION_REASON_UPDATED: 'Rejection Reason updated successfully',
  REJECTION_REASON_DELETED: 'Rejection Reason deleted successfully',
  REJECTION_REASON_IS_PRIORITY_CHANGED: 'Rejection Reason priority changed successfully',
  REJECTION_REASON_SAVE_FAILED: 'Something went wrong while saving the rejection reason.',
  REJECTION_REASON_DELETE_FAILED: 'Something went wrong while deleting the rejection reason.',
  REJECTION_REASON_CODE_UNIQUE: 'Reason code must be unique',

  DOWNTIME_REASON_CREATED: 'Downtime Reason created successfully',
  DOWNTIME_REASON_UPDATED: 'Downtime Reason updated successfully',
  DOWNTIME_REASON_DELETED: 'Downtime Reason deleted successfully',

  DOWNTIME_CATEGORY_CREATED: 'Downtime Category created successfully',
  DOWNTIME_CATEGORY_UPDATED: 'Downtime Category updated successfully',
  DOWNTIME_CATEGORY_DELETED: 'Downtime Category deleted successfully',

  FACTORY_AREA_CREATED: 'Factory Area created successfully',
  FACTORY_AREA_UPDATED: 'Factory Area updated successfully',
  FACTORY_AREA_DELETED: 'Factory Area deleted successfully',

  ROI_CREATED: 'Region of Interest created successfully',
  ROI_UPDATED: 'Region of Interest updated successfully',
  ROI_DELETED: 'Region of Interest deleted successfully',

  // --------------------------------------------- Validation Generic Error
  VALIDATION_FAILED: 'Validation Failed:',

  // --------------------------------------------- Common Http Verbs
  UPDATE: 'Update',
  ADD: 'Add',
  DELETE: 'Delete',
  SEARCH: 'Search...',

  // -------------------------------------------- Print Maintenance form
  PRINT: 'Print',

  // --------------------------------------------- ToolTips
  JOB_DASHBOARD_DOWNLOAD_TOOLTIP: 'Export jobs data csv',
  PBI_REPORT_PDF_DOWNLOAD_TOOLTIP: 'Export Report data pdf',
  PBI_REPORT_PPT_DOWNLOAD_TOOLTIP: 'Export Report data ppt',
  DOWNLOAD_EXCEL_TOOLTIP: 'Download Excel',
  DOWNLOAD_PDF_TOOLTIP: 'Download PDF',
  JOB_DASHBOARD_UPLOAD_TOOLTIP: 'Upload job',
  UPLOAD_PRODUCT_TOOLTIP: 'Upload product',
  UPLOAD_TOOL_TOOLTIP: 'Upload Tool',
  JOB_DASHBOARD_CARD_VIEW_TOOLTIP: 'Job dashboard view',
  JOB_DASHBOARD_GANTT_CHART_VIEW_TOOLTIP: 'Gantt chart view',
  GRID_VIEW_TOOLTIP: 'Grid View',
  CHART_VIEW_TOOLTIP: 'Charts View',

  // --------------------------------------------- CSV File Display Name

  DISP_NAME_PRODUCTS: 'Product',
  DISP_NAME_JOBS: 'Job',
  DISP_NAME_EQUIPMENT: 'Equipment',
  DISP_NAME_QUANTITY: 'Units',
  DISP_NAME_CREATED: 'Date',
  DISP_NAME_FROM_TIME: 'Time (From-To)',
  DISP_NAME_FROM_TIME_PRODUCTION: 'From Time',
  DISP_NAME_PERIOD: 'Period',
  DISP_NAME_IS_MANUAL: 'Is Manual?',

  //------------------------------------------Days tooltips
  SHIFT_MONDAY: 'Monday',
  SHIFT_TUSEDAY: 'Tuseday',
  SHIFT_WEDNESDAY: 'Wednesday',
  SHIFT_THURSDAY: 'Thursday',
  SHIFT_FRIDAY: 'Friday',
  SHIFT_SATURDAY: 'Saturday',
  SHIFT_SUNDAY: 'Sunday',

  // --------------------------------------------- Constants
  LOADING: 'Loading...',
  NOT_AVAILABLE: 'Not Available',
  ALL_FACTORIES: 'All Factories',
  IS_TRACKER_AVAILABLE: 'Not Available',
  TRUE: 'True',
  FALSE: 'False',
  NOT_ATTACHED: 'Not Attached',
  JOB_NAME_NOT_AVAILABLE: 'Job name not Available',
  SPACE: ' ',
  CURRENT_ITEM: 'item_0',
  RED: 'red',
  GREEN: 'green',
  RUNNING: 'Running',
  MACHINE_STATUS: 'Status: ',
  STOPPED: 'Stopped',
  ACTIVE: 'active',
  BALANCE: 'Balance',
  PRODUCTNAME: 'productName',
  DOLLAR: '£',
  SEC: 'sec',
  METERPERMIN: 'm/min',
  PERCENTAGE: '%',
  ZERO_PERCENTAGE: '0%',
  EMPTY_STR: '',
  DATE_FORMAT: 'MMM DD, YYYY',
  DATE_TIME_FORMAT: 'MMM DD, YY HH:mm:ss',
  DATE_TIME_MINUTE_FORMAT: 'MMM DD, YY HH:mm',
  DATE_TIME_FORMAT_IN_REPORTS: 'MMM-DD-YYYY HH:mm:ss',
  DATE_TIME_FORMAT_IN_COMPLAINT: 'HH:mm:ss | MMM-DD-YYYY',
  DATE_TIME_FORMAT_YEAR: 'MMM DD, YY',
  DATE_TIME_HOUR_FORMAT: 'MMM DD, YY HH',

  TIME_FORMAT: 'HH:mm',
  TIME_HOUR_FORMAT: 'HH',
  TIME_YEAR_FORMAT: 'YYYY-MM-DD',
  DATE_MONTH_YEAR_FORMAT: 'DD/MM/YYYY',
  DATEPICKER_TIME_FORMAT: 'HH:mm:ss',
  DATE_ISO_FORMAT: 'YYYY-MM-DDTHH:mm:ss.000',
  DATE_ISO_FORMAT_Z: 'Z',
  NIGHT_SHIFT: 'Night',
  HEADER_TILE_SELECTED_CLASS: 'customHeader_filterSelected',
  EMAIL_FORMAT: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
  MONTHS: ['Jan', 'Feb', 'March', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
  FILTERS: {
    ONE: 1,
    WEEK: 7,
    TWO_WEEK: 14,
    MONTH: 30,
    QUARTER: 90,
  },
  STATES_LIST: [
    { id: 0, name: 'Running' },
    { id: 1, name: 'Not Running' },
  ],
  MACHINE_TYPES_LIST: [
    { id: 0, name: 'Line' },
    { id: 1, name: 'Equipment' },
  ],
  FILTERS_LIST: [
    {
      name: 'Last One Day',
      id: 1,
    },
    {
      name: 'Last 7 days',
      id: 2,
    },
    {
      name: 'Last 14 days',
      id: 3,
    },
    {
      name: 'Last 30 days',
      id: 4,
    },
    {
      name: 'Last 90 days',
      id: 5,
    },
  ],
  SHIFT_DAYS: [
    { label: 'Mon', value: 'Monday' },
    { label: 'Tue', value: 'Tuesday' },
    { label: 'Wed', value: 'Wednesday' },
    { label: 'Thurs', value: 'Thursday' },
    { label: 'Fri', value: 'Friday' },
    { label: 'Sat', value: 'Saturday' },
    { label: 'Sun', value: 'Sunday' },
  ],
  CHART_LAYOUT_SECTIONS: [
    {
      id: 1,
      name: 'OEE',
    },
    {
      id: 2,
      name: 'Availability',
    },
    {
      id: 3,
      name: 'Performance',
    },
    {
      id: 4,
      name: 'Quality',
    },
  ],
  MASTERDATA: 'Master Data',
  AVAILABILITY: 'Availability',
  PERFORMANCE: 'performance',
  QUALITY: 'quality',
  FACTORY_TYPE: 'factoryDropDown',
  FACTORY_FILTERS: 'factoryFilters',
  AUXILIARY_DASDHBOARD_TITLE: 'Auxiliary Dashboard',
  FACTORY_TITLE: 'Factories',
  GROUP_TITLE: 'Groups',
  DOWNTIME_CATEGORY_TITLE: 'Downtime Category',
  DEPARTMENT_TITLE: 'Departments',
  SHIFT_TITLE: 'Shifts',
  EQUIPMENT_TITLE: 'Equipments',
  LINE_TITLE: 'Lines',
  LINE_EQUIPMENT_POSITION: 'Line equipment positions',
  POSITION_TITLE: 'Positions',
  LINE_POSITION_TITLE: 'Line Configuration',
  RAW_MATERIAL_TITLE: 'Raw Materials',
  JOB_TYPE_TITLE: 'Job Types',
  TOOL_TITLE: 'Tools',
  CREWS_TITLE: 'Crews',
  CREW_ROTA_TITLE: 'Rota',
  PRODUCT_TITLE: 'Products',
  USERS_TITLE: 'Users',
  USERS_TOTAL_COUNT_TITLE: 'Total Users',
  DOWNTIME_REASONS_TITLE: 'Downtime Reasons',
  EDIT_FACTORY_DASHBOARD_VIEW: 'Edit Factory Dashboard View',
  REJECTION_REASONS_TITLE: 'Rejection Reasons',
  FACTORY_AREA_TITLE: 'Factory Areas',
  ROI_TITLE: 'Factory Region of Interest',
  FACTORY_REPORT_TITLE: 'Factory Report',
  FACTORY_REPORT_DESC:
    'This report shows machine wise OEE in a given date range. Typical use of this report is to get weekly or monthly machine production data.',
  FACTORY_DETAIL_REPORT_TITLE: 'Factory Detail Report',
  FACTORY_DETAIL_REPORT_DESC:
    'This report shows machine wise OEE in a given date range. Typical use of this report is to get weekly or monthly machine production data.',
  FACTORY_DAY_REPORT_TITLE: 'Factory Day Report',
  FACTORY_DAY_REPORT_DESC:
    'This report shows machine and job wise OEE for all shifts in a selected day. This is the most commonly used report to view daily production performance.',
  SHIFT_REPORT_TITLE: 'Factory Shift Report',
  SHIFT_REPORT_DESC: 'This report only shows stand alone-equipment data excluding any equipment with a line.',
  AUDIT_LOGS_TITLE: 'Audit Logs',
  AUDIT_LOGS_DESC: 'This page displays audit logs for user actions on entities.',
  EQUIPMENT_REPORT_TITLE: 'Equipment Report',
  EQUIPMENT_REPORT_DESC:
    'This report shows production data in a given date range for a particular machine. It contains details of the jobs that have run on that machine.',
  JOB_REPORT_TITLE: 'Job Report',
  JOB_REPORT_DESC:
    'This report shows job analysis given a job. This job can be used to get detail information on current or past jobs',
  ENERGY_REPORT_TITLE: 'Energy Report',
  ENERGY_REPORT_DESC:
    'This report highlights equipment, product and downtime energy consumptions metrics. It acts as a key input to help start your energy conservation journey.',
  PRODUCT_REPORT_TITLE: 'Product Report',
  ADD_PRODUCT_TITLE: 'Add Product',
  EDIT_PRODUCT_TITLE: 'Edit Product',
  PRODUCT_REPORT_DESC: 'This report will help you analyse the data across all jobs given a product',
  DOWNTIME_ANALYSIS_REPORT_TITLE: 'Downtime Analysis Report',
  DOWNTIME_ANALYSIS_DESC:
    'The report help you analyse downtime reasons across the whole factory, machines and various reasons. ',
  TOOL_ANALYSIS_REPORT_TITLE: 'Tool Analysis Report',
  TOOL_ANALYSIS_DESC:
    'The report help you analyse tool change across the whole factory, machines and various reasons. ',
  REJECTION_REPORT_TITLE: 'Rejection Report',
  DOWNTIME_REPORT_TITLE: 'Downtime Report',
  REJECTION_REPORT_DESC: 'This report helps you understand the rejection reasons across factory and products.',
  ACTIVE_JOB_REPORT_DESC: 'This report provides the list of all active jobs at first priority on each machine.',
  ANALYSIS_REPORT_TITLE: ' ANALYSIS Report',
  ANALYSIS_REPORT_DESC_OeeAnalysis: 'This report provides the ability to analyse aggregated OEE data',
  ANALYSIS_REPORT_DESC_V2: 'This report provides the ability to analyse aggregated OEE data',
  EXCEL: 'excel',
  PDF: 'pdf',
  EXCEL_PRODUCT_FILE_NAME: 'product.csv',
  PDF_PRODUCT_FILE_NAME: 'product.pdf',
  PDF_TOOL_ANALYSIS_FILE_NAME: 'Tool_Analysis_',
  PDF_DOWNTIME_ANALYSIS_FILE_NAME: 'Downtime_Analysis_',
  PDF_FACTORY_DETAIL_REPORT_FILE_NAME: 'Factory_Detail_Report_',
  UPLOAD_PRODUCT_FILE_TITLE: 'Upload Product File',
  UPLOAD_TOOL_FILE_TITLE: 'Upload Tool File',
  EXCEL_SAMPLE_PRODUCT_FILE_NAME: 'Thingtrax_Product_Import_Template.csv',
  EXCEL_SAMPLE_PRODUCT_ATTRIBUTE_VALUES_FILE_NAME: 'Thingtrax_Product_Attribute_Values_Import_Template.csv',
  EXCEL_SAMPLE_GLOBAL_ATTRIBUTE_VALUES_FILE_NAME: 'Thingtrax_Product_Attribute_Import_Template.csv',
  EXCEL_SAMPLE_TOOL_FILE_NAME: 'Thingtrax_Tool_Import_Template.csv',
  APPLY_FILTERS: 'Apply Filters',
  RESET_FILTERS: 'Reset Filters',
  CHECK_DATE_FORMAT: [moment.ISO_8601, 'MM/DD/YYYY  :)  HH*mm*ss'],
  YES: 'Yes',
  NO: 'No',
  INDEFINITE: 'Indefinite',
  VIEW_SHIFT_REPORT: 'View Shift Report',
  VIEW_JOB_REPORT: 'View Job Report',
  VIEW_REJECTION_REPORT: 'View Rejection Report',
  VIEW_DOWNTIME_REPORT: 'View Downtime Report',
  VIEW_ENERGY_REPORT: 'View Energy Report',
  VIEW_EQUIPMENT_REPORT: 'View Equipment Report',
  DURATION_OPTIONS: [
    { id: 0, name: 'Hours', prefix: 'hours' },
    { id: 1, name: 'Shift', prefix: 'shift' },
  ],
  SELECT_FACTORY: 'Select Factory',
  DEFAULT_ENERGY_TYPE: 'Energy On Meter',
  EOD_ENERGY_TYPE: 'Energy On Device',
  CT_ENERGY_TYPE: 'Energy On Device',
  DEFAULT_ENERGY_PHASE: 'Single Phase',
  SINGLE_ENERGY_PHASE: 'Single Phase',
  THREE_ENERGY_PHASE: 'Three Phase',
  DEFAULT_CTTYPE: '200A',
  SELECT_DOWNTIME_CATEGORY: 'Select DownTime Category',
  SELECT_EQUIPMENT: 'Select Equipment',
  SELECT_LINE: 'Select Line',
  SELECT_JOB: 'Select Job',
  SELECT_TOOL: 'Select Tool',
  SELECT_SKILL_LEVEL: 'Select Skill Level',
  SELECT_REJECTION_REASON: 'Select Rejection Reason',
  SELECT_SHIFT: 'Select Shift',
  SELECT_PRODUCT: 'Select Product',
  SELECT_JOB_TITLE: 'Select Job Title',

  ADMIN: 'Admin',
  EQUIPMENT_TYPE_LIST: ['Silos', 'Auxiliary', 'Camera', 'Assembly Line'],

  LOCATION_NAME: 'Enter Location Name',
  METRIC_NAME: 'Enter Metric Name',
  SELECT_TYPE: 'Select Type',

  CONTAINMENT_ACTIONS_LOCATION_SUCCESS_ADD: 'Location added successfully!',
  CONTAINMENT_ACTIONS_LOCATION_SUCCESS_UPDATE: 'Location updated successfully!',
  CONTAINMENT_ACTIONS_LOCATION_SUCCESS_DELETE: 'Location deleted successfully!',

  CONTAINMENT_ACTIONS_METRIC_SUCCESS_ADD: 'Metric added successfully!',
  CONTAINMENT_ACTIONS_METRIC_SUCCESS_UPDATE: 'Metric updated successfully!',
  CONTAINMENT_ACTIONS_METRIC_SUCCESS_DELETE: 'Metric deleted successfully!',

  CONTAINMENT_ACTIONS_METRIC_ADD_NEW: 'Add new metric',
  CONTAINMENT_ACTIONS_LOCATION_ADD_NEW: 'Add new location',
  QUALITY_ASSURANCE_DASHBOARD_TOOLTIP_VIEW_IMAGE: 'View Image',

  C_SUITE_DASHBOARD_ADD_KPI_METRIC_ERROR_NO_MORE_KPI: 'All the metrics have been selected in the dashboard!',
  C_SUITE_DASHBOARD_ADD_KPI_METRIC_TITLE_REQUIRED: 'Metric Title is required!',
  C_SUITE_DASHBOARD_ADD_KPI_METRIC_TARGET_MIN_REQUIRED: 'Target Value Min is required!',
  C_SUITE_DASHBOARD_ADD_KPI_METRIC_TARGET_MAX_REQUIRED: 'Target Value Max is required!',
  C_SUITE_DASHBOARD_ADD_KPI_TARGET_MIN_SHOULD_GREATER_STRETCH_TARGET:
    'Target Value should be greater than Stretch Target Value!',
  C_SUITE_DASHBOARD_ADD_KPI_TARGET_MIN_SHOULD_LOWER_STRETCH_TARGET:
    'Target Value should be lower than Stretch Target Value!',
  C_SUITE_DASHBOARD_ADD_KPI_STRETCH_TARGET_SHOULD_GREATER_TARGET:
    'Stretch Target Value should be greater than Target Value!',
  C_SUITE_DASHBOARD_ADD_KPI_STRETCH_TARGET_SHOULD_LOWER_TARGET:
    'Stretch  Target Value should be lower than Target Value!',
  C_SUITE_DASHBOARD_ADD_KPI_VALUE_SHOULD_GREATER_THAN_ZERO: 'Value should be greater than zero!',
  C_SUITE_DASHBOARD_ADD_KPI_TARGET_MIN_VALIDATION_MAX_TARGET: 'Target Value Min must be lower than Target Value Max!',
  C_SUITE_DASHBOARD_ADD_KPI_METRIC_TARGET_MAX_VALUE_REQUIRED: 'Target Value Max is required!',
  C_SUITE_DASHBOARD_ADD_KPI_METRIC_TARGET_MIN_VALUE_REQUIRED: 'Target Value Min is required!',
  C_SUITE_KPI_CREATED: 'KPI created successfully',
  POSITION_TYPE_RLE: 'RLE',
  POSITION_TYPE_NORMAL: 'Normal',
  POSITION_TYPE_OP: 'OP',
  GOOD_PRODUCTION: 'GOOD PRODUCTION',
  MOVE_POSITION_DOWN: 2,
  MOVE_POSITION_UP: 1,
  C_SUITE_CHART_COLOR_CODE_GREEN: '#01c25f',
  C_SUITE_CHART_COLOR_CODE_RED: '#FF4843',
  C_SUITE_CHART_COLOR_CODE_LIGHT_BLUE: '#01C7FE',
  C_SUITE_CHART_COLOR_CODE_GRAY: '#D0CFCE',

  FACTORY_EFFICIENCY_CARD_TYPE_LINE: 'LINE',
  FACTORY_EFFICIENCY_CARD_TYPE_EQUIPMENT: 'EQUIPMENT',
  FACTORY_EFFICIENCY_DASHBOARD_LINK: '/dashboard/factoryEfficiency/',
  ENTER_CREW_NAME: 'Enter Crew Name',
  CREW_CREATED: 'Crew created successfully',
  CREW_ROTA_UPLOADED: 'Crew uploaded successfully',
  CREW_UPDATED: 'Crew updated successfully',
  CREW_DELETED: 'Crew deleted successfully',

  SCRAP_QUANTITY_SHOULD_BE_GREATER_THAN_ZERO: 'Quantity should be greater than zero',
  REWORK_QUANTITY_SHOULD_BE_GREATER_THAN_ZERO: 'Quantity should be greater than zero',
  REWORK_QUANTITY_SHOULD_BE_INTEGER: 'Quantity should be integer',
  SCRAP_QUANTITY_SHOULD_NOT_BE_GREATER_THAN_OP: 'Quantity should not be greater than output point production',
  WEIGHT_TO_QUANTITY_WARNING_TITLE: 'Unit Count',
  WEIGHT_TO_QUANTITY_WARNING: 'The weight you have entered equates to ({0}) units. This has been rounded to ({1})',
  REWORK_QUANTITY_SHOULD_BE_Equal_OR_LOWER_THAN_ACCUMULATION_SIZE:
    'Quantity should be equal or lower than accumulation size which is ({0})',
  REWORK_WEIGHT_SHOULD_BE_Equal_OR_LOWER_THAN_ACCUMULATION_SIZE:
    'Quantity, in terms of Weight, should be equal or lower than accumulation size which is ({0})',
  SCRAP_QUANTITY_SHOULD_BE_Equal_OR_LOWER_THAN_CURRENT_SHIFT_PRODUCTION:
    'Quantity should be equal or lower than current shift prodcution which is ({0})',
  SCRAP_WEIGHT_SHOULD_BE_Equal_OR_LOWER_THAN_CURRENT_SHIFT_PRODUCTION:
    'Quantity, in terms of Weight, should be equal or lower than current shift prodcution which is ({0})',
  ENTER_SCRAP_QUANTITY: 'Enter Rejection Quantity',
  SELECT_SCRAP_REASON: 'Select Rejection Reason',
  ADD_SCRAP_COMMENT: 'Add comment in Rejection',
  ADD_REWORK_COMMENT: 'Add comment in Rework',
  ADD_GOOD_PRODUCTION_COUNT_COMMENT: 'Add comment in Good Production Count',
  ENTER_Shift: 'Select Shift',
  ENTER_REWORK_QUANTITY: 'Enter Rework Quantity',
  ENTER_GOOD_Count_QUANTITY: 'Enter Good Count Quantity',

  PALLET_SIZE: 'Enter Pallet Size',
  CASE_SIZE: 'Enter Case Size',
  PACK_SIZE: 'Enter Pack Size',
  PACK_SIZE_GREATER_THAN_ZERO_REQUIRED: 'Pack Size should be greater than 0!',
  CASE_SIZE_GREATER_THAN_ZERO_REQUIRED: 'Case Size should be greater than 0!',
  PALLET_SIZE_GREATER_THAN_ZERO_REQUIRED: 'Pallet Size should be greater than 0!',

  JOB_DASHBOARD_JOB_MOVE_EQUIPMENT_TO_LINE_ERROR: "Can't move job from equipment to line!",
  CREW_ROTA_TABLE_CSS_CLASS_PAST: 'rota-table-shift-past',
  CREW_ROTA_TABLE_CSS_CLASS_CURRENT: 'rota-table-shift-current',
  CREW_ROTA_TABLE_CSS_CLASS_FUTURE: 'rota-table-shift-future',

  ACCUMULATION_RECORD_TYPE_SCRAP: 'SCRAP',
  ACCUMULATION_RECORD_TYPE_REWORK: 'REWORK',

  LINE_CARD_ATTACH_EQUIPMENT: 'attach',
  LINE_CARD_DETACH_EQUIPMENT: 'detach',
  DETACH_AUTOMATION_COMMENT: 'Add comment',

  // Factory Efficiency
  ENTER_DEFAULT_UNIT_PER_CYCLE: 'Please Enter Unit Per Cycle',
  UNIT_PER_CYCLE_IS_REQUIRED: 'Unit Per Cycle is requierd',
  UNIT_PER_CYCLE_SHOULD_BE_GREATER_THAN_ZERO: 'Unit Per Cycle should be greater than zero',
  ENTER_DEFAULT_CASE_QUANTITY: 'Please Enter Case Quantity',
  CASE_QUANTITY_IS_REQUIRED: 'Case Quantity is requierd',
  CASE_QUANTITY_SHOULD_BE_GREATER_THAN_ZERO: 'Case Quantity should be greater than zero',
  ENTER_DEFAULT_PACK_QUANTITY: 'Please Enter Pack Quantity',
  PACK_QUANTITY_IS_REQUIRED: 'Pack Quantity is requierd',
  PACK_QUANTITY_SHOULD_BE_GREATER_THAN_ZERO: 'Pack Quantity should be greater than zero',
  ENTER_DEFAULT_PALLET_QUANTITY: 'Please Enter Pallet Quantity',
  PALLET_QUANTITY_SHOULD_BE_GREATER_THAN_ZERO: 'Pallet Quantity should be greater than zero',
  PALLET_QUANTITY_IS_REQUIRED: 'Pallet Quantity is requierd',
  ENTER_ACCUMULATION_SIZE: 'Please Enter Accumulation Size',
  ACCUMULATION_SIZE_SHOULD_BE_POSITIVE: 'Accumulation Size should be greater than zero',
  ACCUMULATION_SIZE_IS_REQUIRED: 'Accumulation Size is requierd',

  SCRAP_SHOULD_BE_POSITIVE: 'Rejection should be greater than zero or equal to zero',
  ENTER_DEFAULT_SCRAP: 'Please Enter Rejection Quantity',
  ENTER_DEFAULT_REWORK: 'Please Enter Rework Quantity',
  ENTER_DEFAULT_GOOD_PART: 'Please Enter Good Parts Quantity',
  REWORK_SHOULD_BE_POSITIVE: 'Rework should be greater than zero or equal to zero',
  GOOD_PART_SHOULD_BE_POSITIVE: 'Good Part should be greater than zero or equal to zero',
  //end Factory Efficiency

  VERTICAL_LEFT: 'left',
  VERTICAL_RIGHT: 'right',
  REJECTION_REASON_NOT_ALLOWED_ADD_MORE_THAN_10_PRIORITY: 'Not allowed to add more than 10 priority rejection reason',
  WHATFIX_LOCAL_SRC:
    'https://eucdn.whatfix.com/prod/a87d7d52-8c3e-4ece-8f80-57020bf30018/initiator/initiator.nocache.js',
  WHATFIX_CLIENT_SRC:
    'https://eucdn.whatfix.com/prod/3bc7aa99-7772-449d-a37d-877ddf629da3/initiator/initiator.nocache.js',

  AUTOMATION_HAS_ATTACHED_TO_LINE_SUCCESSFULLY: 'Automation attached to the line successfully.',
  AUTOMATION_HAS_DETACHED_FROM_LINE_SUCCESSFULLY: 'Automation detached from the line successfully.',
  AUTOMATION_HAS_RECONCILIATED_SUCCESSFULLY: 'Automation has reconciliated successfully.',
  //Response Model Status Codes
  Http_Status_Code_OK: '200',
  Http_Status_Code_FORBIDDEN: '400',
  //End Response Model Status Codes
  None: '',
  MODEL_IS_NOT_TRAINED: 'Model is not trained',
  MODEL_IS_TRAINED: 'Model is trained',
  IMAGE_VALIDATION_SUCCESS: 'Product image is validated',
  IMAGE_VALIDATION_INFO: 'Product image is not validated',
  INTERNAL_SERVER_ERROR: 'Internal server error',
  MODEL_TRAINED: 'Success',
  MODEL_NOT_TRAINED: 'Model Not Trained',
  VALIDATE_PRODUCT_MODEL_FAILED: 'Failed',
  VALIDATE_PRODUCT_MODEL_SUCCESS: 'Success',
  CAMERA_NOT_RESPONDING: '{EquipmentName} is not responding. Make sure camera is connected and powered on.',
  CAMERA_JOB_CONFLICT: '{EquipmentName} already has an active job.',
  EQUIPMENT_EMPTY_ATTRIBUTES:
    'There is a conflict in the product attributes associated with {EquipmentName}. Please review the project configuration.',
  ERROR_TYPE_JOB_STATE_CONFLICT: 'job_state_conflict',
  ERROR_TYPE_CAMERA_STOPPED: 'camera_stopped',
  ERROR_TYPE_EMPTY_ATTRIBUTES: 'job_attribute_conflict',
  ERROR_TYPE_JSON_DESERIALIZATION_ERROR: 'JSON_DESERIALIZATION_ERROR',
  VISION_ERROR_NOTIFICATION_DURATION: 15,
  SWITCH_PRODUCT_SUCCESS: 'Success',
  JOB_PRODUCT_MODEL_IS_NOT_TRAINED:
    'The job for this product cannot be started as the vision system is not trained for it. Please contact Thingtrax team at support@thingtrax.com',
  SERVER_ERROR:
    'The job for this product cannot be processed as the vision system is not reachable. Please contact Thingtrax team at support@thingtrax.com',
  SERVER_ERROR_STOPPED:
    'The job for this product cannot be started as the vision system is not reachable. Please contact Thingtrax team at support@thingtrax.com',
  EQUIPMENT_AND_LINE_WRONG:
    'The job for this product cannot be started as the vision system is not trained for it. Please contact Thingtrax team at support@thingtrax.com',
  DEVICE_NAME_WRONG: 'EquipmentName or LineName is either invalid or absent',

  LINE_JOB_CARD_ACTION_REFRESH: '300',
  ON: 'On',
  OFF: 'Off',
  PLC_STATUS_CHANGED_SUCCESFULLY: 'Plc status changed successfully.',
  PLC_SERVER_ERROR:
    'The vision system is not reachable for this job. Please contact Thingtrax team at support@thingtrax.com',
  EQUIPMENT_TYPE_SHORT: 'Equipment Type',
  EQUIPMENT_JOB_TITLE: 'All Job Title',
  INVALID_TOKEN_FORMAT: 'Invalid token format',
  THINGTRAX_API_ERROR: 'Error while fetching from THINGTRAX API',
  UPDATE_PLANNED_UNPLANNED_DOWNTIME_REASON:
    'Not allowed to update downtime reasons from planned to unplanned category or vise versa.',
  ISLIVE: 'isLive',
  ISHISTORIC: 'isHistoric',

  VISION_PROJECT_NAME_PLACEHOLDER: 'Enter Vision Project Name',
  VISION_PROJECT_USE_CASE: 'Select UseCase',
  VISION_PROJECT_ADD_SUCCESSFULLY: 'Vision Project has been added successfully',
  VISION_PROJECT_UPDATE_SUCCESSFULLY: 'Vision Project has been updated successfully',
  VISION_PROJECT_ARTWORK_UPDATE_SUCCESSFULLY: 'Vision Project Artwork has been updated successfully',
  VISION_PROJECT_DELETE_SUCCESSFULLY: 'Vision Project has been deleted successfully',
  VISION_PROJECT_ARTWORK_DELETE_SUCCESSFULLY: 'Vision Project Artwork has been deleted successfully',
  VISION_PROJECT_PRODUCT_DELETE_SUCCESSFULLY: 'Vision Project Product has been deleted successfully',
  VISION_PROJECT_VIDEO_DELETE_SUCCESSFULLY: 'Vision Project Video has been deleted successfully',
  VISION_PROJECT_IMAGE_DELETE_SUCCESSFULLY: 'Vision Project Image has been deleted successfully',
  VISION_PROJECT_AOI_DELETE_SUCCESSFULLY: 'Area of Interest has been deleted successfully',
  VISION_PROJECT_AOI_ADD_SUCCESSFULLY: 'Area of Interest has been added successfully',
  VISION_PROJECT_AOI_REMOVED_SUCCESSFULLY: 'has been removed from your project',
  VISION_PROJECT_AOI_ALREADY_IN_LIST: 'is already in your list',
  VISION_PROJECT_AOI_DELETE_ERROR: 'Failed to delete AOI',
  VISION_PROJECT_AOI_REMOVE_ERROR: 'Failed to remove AOI from project',
  VISION_PROJECT_AOI_INPUT_PLACEHOLDER: 'Enter new AOI label...',
  VISION_PROJECT_AOI_DUPLICATE_IN_GLOBAL: 'Global AOIs',
  VISION_PROJECT_AOI_DUPLICATE_IN_CUSTOM: 'Custom AOIs',
  VISION_PROJECT_AOI_DUPLICATE_MESSAGE: 'Name already exists in',
  VISION_PROJECT_AOI_TOOLTIP_RANDOM_COLOR: 'Generate random color',
  VISION_PROJECT_AOI_TOOLTIP_CLICK_TO_ADD: 'Click on a label to add it to your project',
  VISION_PROJECT_IMAGE_ANNOTATIONS_ADD_SUCCESSFULLY: 'Image annotations has been added successfully',
  VISION_PROJECT_IMAGE_ANNOTATIONS_UPDATE_SUCCESSFULLY: 'Image annotations has been updated successfully',
  VISION_PROJECT_IMAGE_ANNOTATIONS_BULK_SAVE_SUCCESSFULLY: 'Annotations have been saved successfully',
  VISION_PROJECT_IMAGE_ANNOTATIONS_DELETE_SUCCESSFULLY: 'Image annotations has been deleted successfully',
  VISION_PROJECT_AOI_UPDATED_SUCCESSFULLY: 'Area of Interest has been updated successfully',
  VISION_PROJECT_START_MODEL_TRAINING_SUCCESSFULLY: 'Model training started successfully!',
  VISION_PROJECT_START_MODEL_TRAINING_ERROR: 'Model training failed to start.',
  VISION_PROJECT_MODEL_DEPLOYED_SUCCESSFULLY: 'Model deployment started successfully!',
  VISION_PROJECT_MODEL_DEPLOY_FAILED: 'Failed to deploy model.',
  VISION_PROJECT_MODEL_DEPLOY_ERROR: 'An error occurred during deployment.',
  VISION_PROJECT_DEFINE_AOI: 'Define Area of Interest',
  VISION_PROJECT_AOI_ADD: 'Add',
  VISION_PROJECT_AOI_UPDATE: 'Update',
  VISION_PROJECT_AOI: 'AOI',
  VISION_PROJECT_IMAGE: 'IMAGE',
  VISION_PROJECT_USE_CASE_LABEL_VALIDATION: 'Label Validation',
  VISION_PROJECT_USE_CASE_PRODUCT_COUNT: 'Product Count',
  VISION_PROJECT_TOOLS: {
    DEFECT: 'defect',
    HEIGHT: 'height',
    WIDTH: 'width',
    LENGTH: 'length',
    COUNT: 'count',
    QR: 'qr',
    OCR: 'ocr',
  },
  VISION_PROJECT_DATA_TYPES: {
    DECIMAL: 'Decimal',
    BOOLEAN: 'Boolean',
    ALPHANUMERIC: 'Alphanumeric',
    DATE: 'Date',
    JULIAN_DATE: 'Julian Date',
  },
  VISION_PROJECT_TRAINING_STOPPED_FAILED: 'Failed to stop training',
  VISION_PROJECT_AOI_UNIQUE_ERROR: 'The Name and Color must be unique',
  VISION_PROJECT_IMAGE_ANNOTATIONS_ERROR: 'An issue accured in adding annotations into image',
  VISION_PROJECT_AOI_NAME_VALIDATION_ERROR: 'Please Enter a Name',
  VIEW_VISION_PROJECT_DETAILS: '/dashboard/masterdata/visionProjectDetails/',
  VIEW_VISION_PROJECT_STATUS: '/dashboard/masterdata/visionProjectStatus/',
  VIEW_VISION_PROJECT_CONFIGURATION_UPLOAD_IMAGE: '/dashboard/masterdata/visionProjectConfiguration/{id}/upload_images',
  VIEW_VISION_PROJECT_CONFIGURATION_ANNOTATE_IMAGES:
    '/dashboard/masterdata/visionProjectConfiguration/{id}/annotate_images',
  VIEW_VISION_PROJECT_CONFIGURATION_DEFINE_OBJECTS:
    '/dashboard/masterdata/visionProjectConfiguration/{id}/define_objects',
  VIEW_VISION_PROJECT_CONFIGURATION_STEP: '/dashboard/masterdata/visionProjectConfiguration/{id}/{step}',

  //VISION PROJECTS
  VISION_PROJECT_TOTAL_COUNT: 'Total Projects:  ',
  // VISION AI PROJECT CONFIGURATION STEPS
  VPC_STEP_UPLOAD_IMAGES: 'UPLOAD_IMAGES',
  VPC_STEP_DEFINE_OBJECTS: 'DEFINE_OBJECTS',
  VPC_STEP_ANNOTATE_IMAGES: 'ANNOTATE_IMAGES',
  VPC_STEP_TRAIN_MODEL: 'TRAIN_MODEL',
  VPC_STEP_TEST: 'TEST',
  VPC_STEP_CONFIGURATION: 'CONFIGURATION',
  VPC_STEP_DEPLOY: 'DEPLOY',
  SELECT_CAMERA: 'Select Camera',
  EQUIPMENT_TOTAL_COUNT_TITLE: 'Total Equipments:  ',

  VPC_STEP_NEXT: 'Next',
  VPC_STEP_PREVIOUS: 'Previous',
  ATTRIBUTE_PLACEHOLDER: 'Enter Attribute Name',

  VISION_PROJECT_IMAGE_ANNOTATION_HEIGHT: 550,
  VISION_PROJECT_IMAGE_ANNOTATION_WIDTH: 800,

  VPC_BTN_IMAGES: 'UPLOAD_IMAGE_FILES',
  VPC_BTN_VIDEO: 'UPLOAD_VIDEO_FILES',
  LINE_JOB_SELECT_VISION_PROJECT: 'Select vision project',

  FILE_TYPE_VIDEO: 'Video',
  VISION_GATEWAY_URL: 'Vision Gateway Url',
  JOB_IMAGES_LINK: '/dashboard/jobImages/:factoryId/:jobId',
  JOB_IMAGES_TOOLTIP: 'Job Images',
  VISION_CONFIGURATION: 'Vision Project Configuration',
  VISION_EQUIPMENT: 'Vision Equipment',
  VIDEO_MAXIMUM_FILE_SIZE: 100000000,

  VPC_UPLOAD_VIDEO_STATUS_PENDING: 'pending',

  JOB_MODAL_STANDALONE_EQUIPMENT_VISION_PROJECT_REQUIRED: 'Vision Project is required!',

  VPC_BTN_TEST_MODEL: 'TEST_MODEL',
  REJECTION_UNIT: '1',
  REJECTION_WEIGHT: '2',
  DASHBOARD_OEE_EQUIPMENT_BREADCRUMB_TITLE: 'Equipment Efficiency',
  REPORTS_BREADCRUMB_TITLE: 'Reports',
  SHIFT_REPORT_BREADCRUMB_TITLE: 'Shift Report',
  AUDIT_LOGS_BREADCRUMB_TITLE: 'Audit Logs',
  QUALITY_ASSURANCE: 'QUALITY ASSURANCE',
  QUALITY_ASSURANCE_NEW_COMPLAINT: 'NEW COMPLAINT',
  CONTAINMENT_ACTIONS: 'CONTAINMENT ACTIONS',
  QUALITY_ASSURANCE_TITLE: 'Containment Actions',
  QUALITY_ASSURANCE_DESCRIPTIONS: 'Your Location and Metric information for the QA process',
  PENDING: 'Pending',
  PROCESSING: 'Processing',
  PROCESSED: 'Processed',
  FAILED: 'Failed',
  COMPLETED: 'Completed',
  IN_PROGRESS: 'in-progress',

  COLLAPSE_ALL: 'Collapse All',
  EXPAND_ALL: 'Expand All',
  IS_ONEAPP: 'isOneApp',
  VIEW_JOB_IMAGES_LINK: '/dashboard/viewJobImages/',

  VISION_PROJECT_JSON_CONFIGURATION_ROI: {
    enabled: false,
    coordinate: [50, 50, 50, 50],
  },
  VISION_PROJECT_JSON_CONFIGURATION_PLC_ACTIONS: [
    {
      name: 'rejection',
      enable: false,
      pin: 'io1',
      action: {
        cmd_delay: 0.3,
        state1: 'high',
        delay: 0.5,
        state2: 'low',
      },
    },
  ],
  DYNAMIC: 'dynamic',
  USER_DEFINED: 'user_defined',

  PRIVACY_POLICY_LABEL: 'Privacy Policy',
  PRIVACY_POLICY_URL: 'https://www.thingtrax.com/privacy',
  PRIVACY_POLICY_CONSENT_TITLE: 'We value your privacy',
  PRIVACY_POLICY_CONSENT_MESSAGE:
    "We use cookies to provide essential website functionality and improve your experience. Some cookies are strictly necessary for the operation of our site and to remember your preferences, therefore, these cannot be disabled. When you visit our website, if you give your consent, we will also use functional cookies to improve usability, support aggregated analytics, and enhance performance. If you do not consent, we will only use cookies required to remember your choice (i.e., essential cookies). If you don't select any option, no cookies will be deployed, and this banner will reappear every time you visit. For more details, please see our",
  MASTERDATA_DOWNTIME_REASON_HIGHLIGHTS: '/dashboard/masterdata/downtimeReasonHighlights',
  ERP_IMPORT_LINE_JOB: 'ERP Import line job',
  ERP_IMPORT_USER: { email: 'ERP Import line job', name: 'ERP Import line job' },

  MASTERDATA_AUDIT_LOGS_ACTION_OPTIONS: [
    { label: 'Create', value: 'Create' },
    { label: 'Update', value: 'Update' },
    { label: 'Delete', value: 'Delete' },
    { label: 'Complete', value: 'Complete' },
    { label: 'Move', value: 'Move' },
  ],
  MASTERDATA_AUDIT_LOGS_ENTITY_OPTIONS: [
    { label: 'LineJob', value: 'LineJob' },
    { label: 'Job', value: 'Job' },
    { label: 'Tool', value: 'Tool' },
    { label: 'Product', value: 'Product' },
    { label: 'Downtime', value: 'Downtime' },
    { label: 'Product Attributes', value: 'ProductAttribute' },
  ],
  TELEMETRY_TYPE_VALVES: 'Valves',
  TELEMETRY_TYPE_PULSE: 'Pulse',
  DISPLAY_METRICS: ['Default', 'Cycle', 'Pulse'],
  DISPLAY_METRIC_DEFAULT: 'Default',
  DISPLAY_METRIC_CYCLE: 'Cycle',
  DISPLAY_METRIC_PULSE: 'Pulse',
  OEE_EQUIPMENT_DASHBOARD_SHIFT_VIEW: 'shift',
  OEE_EQUIPMENT_DASHBOARD_JOB_VIEW: 'job',
  REJECTION_TYPES: {
    PRODUCT_LOSS: 'Product Loss',
    TIME_LOSS: 'Time Loss',
    OUT_OF_SPECIFICATION: 'Out Of Specification',
  },
};
